<template>
  <div class="vld-parent" ref="thisMainDiv">
    <!-- THE HEADER SHOWING PROGRESS OF THE BOOKING -->
    <header class="tempus-iframe-nav">
      <ul class="tempus-iframe-nav-ul">
        <li class="tempus-iframe-nav-tab" :class="itemSelectedForPurchase ? 'complete' : ''">
          <button
            :disabled="calendarDisabled || saleInProgress"
            @click="calendarClicked"
            class="nav-link"
            :class="calendarDisabled ? 'nav-link-disabled' : ''"
            id="calendar-tab">
            <template v-if="! itemSelectedForPurchase">
              <i class="material-icons">widgets</i>
            </template>
            <template v-else>
              <i class="material-icons">done_outline</i>
            </template>
            <p class="">Choose Your Adventure</p>
          </button>
        </li>

        <li class="tempus-iframe-nav-tab" :class="itemConfirmedForPurchase ? 'complete' : ''">
          <button
            @click="purchaseDetailsClicked"
            :disabled="detailsDisabled"
            class="nav-link"
            :class="detailsDisabled ? 'nav-link-disabled' : ''"
            id="details-tab">
            <template v-if="! itemConfirmedForPurchase">
              <i class="material-icons">event</i>
            </template>
            <template v-else>

              <i class="material-icons">done_outline</i>
            </template>
            <p class="">Purchase Details</p>
          </button>
        </li>

        <li class="tempus-iframe-nav-tab" :class="customerDetailsPresent ? 'complete' : ''">
          <button
            @click="customerClicked"
            :disabled="customerDisabled"
            class="nav-link"
            :class="customerDisabled ? 'nav-link-disabled' : ''"
            id="customer-tab">
            <template v-if="! customerDetailsPresent">
              <i class="material-icons">face</i>
              <p class="">About You</p>
            </template>
            <template v-else>
              <i class="material-icons">done_outline</i>
              <p class="">Your Details Entered</p>
            </template>
          </button>
        </li>

        <li class="tempus-iframe-nav-tab" :class="showPaymentHandler ? 'complete' : ''">
          <button
            @click="paymentClicked"
            :disabled="paymentDisabled"
            class="nav-link"
            :class="paymentDisabled && ! selectedCustomer ? 'nav-link-disabled' : ''"
            id="payment-tab">
            <template v-if="! showPaymentHandler">
              <i class="material-icons">shopping_cart</i>
            </template>
            <template v-else>
              <i class="material-icons">done_outline</i>
            </template>
            <p class="">Payment</p>
          </button>
        </li>

        <li class="tempus-iframe-nav-tab" :class="showSummary ? 'complete' : ''">
          <button
            @click="summaryClicked"
            :disabled="summaryDisabled"
            class="nav-link"
            :class="summaryDisabled ? 'nav-link-disabled' : ''"
            id="summary-tab">
            <template v-if="! showSummary">
              <i class="material-icons">info</i>
            </template>
            <template v-else>
              <i class="material-icons">done_outline</i>
            </template>
            <p class="">Summary</p>
          </button>
        </li>
      </ul>

      <div class="container-fluid text-right">
        <button
          class="calendarWeekGrid_Button_PrevNext"
          data-toggle="tooltip"
          data-placement="bottom"
          title="Help!"
          @click="showHelpDiv = ! showHelpDiv">
          <span class="material-icons">help</span>
        </button>
      </div>

      <div class="container text-white pb-2" v-if="showHelpDiv">
        <h5 class="heading"><span class="material-icons">help</span> Booking &amp; Voucher Purchase Help</h5>

        <p v-if="! itemSelectedForPurchase && ! itemConfirmedForPurchase && ! customerDetailsPresent && ! showPaymentHandler && !showSummary">To start your purchase ensure you have selected the item you wish to purchase, below.</p>

        <p v-if="itemSelectedForPurchase&& ! showSummary">At least one item has been selected for purchase, complete further details to complete your purchase. Click <button class="btn btn-text font-weight-bold text-tempus-blue-tint" @click="calendarClicked">Choose Your Adventure</button> to add additional products to your basket.</p>

        <p v-if="itemConfirmedForPurchase && ! showSummary">At least one item has been confirmed for purchase, now input your details to complete your purchase. Use the buttons at the top to go back to previous steps.</p>

        <p v-if="customerDetailsPresent && ! showSummary">Review your shopping cart and either added extra items using the above buttons, or checkout and complete the purchase.</p>

        <p v-if="showSummary">Your purchase is now complete, you should have received email confirmation of this. To purchase more items, refresh the page or click <span class="font-weight-bold text-tempus-blue-tint">Choose Your Adventure</span>.</p>
      </div>

      <div class="container text-center" ref="chooseTabs" id="chooseTabs">
        <div class="choose-tabs" :class="location.virtual_games && location.virtual_games.length ? 'has-virtual-games' : ''">
          <template v-if="location.virtual_games && location.virtual_games.length">
            <input id="tab_virtual" type="radio" class="tab tab-selector" value="booking-calendar-sub-component-virtual-games" v-model="bookingVueComponent" />
            <label for="tab_virtual" class="tab tab-primary" :class="saleInProgress ? 'tab-disabled' : ''" @click.prevent="showRoomCalendarConfirm(null, $event)">Online<br>Games</label>
          </template>

          <input id="tab_rooms" type="radio" class="tab tab-selector" value="booking-calendar-sub-component-room-week-grid" />
          <label for="tab_rooms" class="tab tab-primary nav-link dropdown-toggle" data-toggle="dropdown" @click.prevent="roomDropdownClicked" :class="saleInProgress ? 'tab-disabled' : ''">
            Room
          </label>
          <div class="dropdown-menu">
            <a v-for="room in openRooms" class="dropdown-item" href="#" @click.prevent="showRoomCalendarConfirm(room, $event)">{{ room.name }}</a>
          </div>

          <input id="tab_all_rooms" type="radio" class="tab tab-selector" value="booking-calendar-sub-component-all-rooms-grid" v-model="bookingVueComponent" />
          <label for="tab_all_rooms" class="tab tab-primary" :class="saleInProgress ? 'tab-disabled' : ''" @click.prevent="showRoomCalendarConfirm(null, $event)">All<br>Rooms</label>

          <input id="tab_vouchers" type="radio" class="tab tab-selector" value="gift-voucher-sub-component" v-model="bookingVueComponent" :disabled="saleInProgress"/>
          <label for="tab_vouchers" class="tab tab-primary" :class="saleInProgress ? 'tab-disabled' : ''" @click="showRoomCalendarConfirm('VOUCHERS', $event)">Gift<br>Vouchers</label>
        </div>
      </div>

      <booking-checkout-cart-summary-header
        v-if="iframeScrollTransition || showCalendar"
        :location="location"
        :cart="cart"
        :pricing-style="pricingStyle"
        ref="cartSummaryHeader"
        @change="cartRefreshed"
        @empty-cart="cartEmpty"
        @go-to-checkout="goToCheckout"></booking-checkout-cart-summary-header>
    </header>

    <main :class="headerClass" ref="main">
      <div class="container-fluid px-0">
        <div v-if="showCalendar" class="" id="calendar" ref="calendar">
          <!-- CALENDARS -->
          <component
            v-if="bookingVueComponent != 'gift-voucher-sub-component'"
            ref="bookingCalendarComponent"
            :is="bookingVueComponent"
            :location="location"

            :booking-room-id="room ? room.id : null"

            :brand="location.brand"

            :date="date"

            :room-slots="roomSlots"
            :rooms-available="roomsAvailable"
            :max-per-row="maxPerRow"

            :customer-request-marketing-permission="customerRequestMarketingPermission"

            :sale-from="saleFrom"
            :location-discount="locationDiscount"
            :location-child-pricing="locationChildPricing"
            :adult-pricing-not-player-pricing="adultPricingNotPlayerPricing"

            :booking-label-state-locked="bookingLabelStateLocked"
            :booking-label-state-booked="bookingLabelStateBooked"

            :axe-throwing="false"

            :initial-cart="cart"

            :show-call-to-book-as-sold="showCallToBookAsSold"
            :show-duration="showDuration"
            :show-players="showPlayers"
            :use-short-room-name="useShortRoomName"
            :deployment-bg-class="deploymentBgClass"

            @publish-room-slots="publishRoomSlots"
            @publish-rooms-available="publishRoomsAvailable"

            @differing-calendar-clicked="showRoomCalendar"

            @date-changed="dateChanged"

            @show-call-to-book="showCallToBook"
            @attempt-to-unlock-slot="attemptToUnlockSlot"
            @add-room-slot-to-pre-cart="addRoomSlotToPreCart">
          </component>

          <component
            v-else-if="bookingVueComponent == 'gift-voucher-sub-component'"
            ref="voucherComponent"
            :is="bookingVueComponent"

            :has-multiple-locations="hasMultipleLocations"
            :location="location"
            :location-voucher-products="locationVoucherProducts"
            :location-discount="locationDiscount"
            :post-cutoff="postCutoff"
            :brand="brand"
            :sell-postal-voucher="sellPostalVoucher"
            :collect-voucher="collectVoucher"
            :expiry="voucherExpiry"
            :voucher-universal="voucherUniversal"
            :voucher-calculator-amounts="voucherCalculatorAmounts"
            :selected-customer="selectedCustomer"
            :deployment-bg-class="deploymentBgClass"
            :pricing-style="pricingStyle"

            :selected-voucher-product="selectedVoucherRequest"

            @scroll-dom-to-precise="scrollDomIdIntoView('voucherConfirmationBeforeCarting')"
            @get-customer-details="getCustomerDetails"
            @select-voucher-product="addVoucherRequestToSelected"
            @add-voucher-to-cart="addVoucherToCart">
          </component>

        </div>
        <div v-else class="tempus-iframe-no-cal">
          <div class="container text-center">
            <template v-if="saleInProgress">
              <h4 class="heading py-4 font-italic">Sale is in progress.</h4>
            </template>
            <template v-else-if="false">
              <h4 class="heading py-4 font-italic">Use the above buttons to select a Calendar for a Booking or a Gift Voucher to purchase.</h4>
            </template>
          </div>
        </div>

        <div v-show="showDetails" class="" id="details" ref="details">
          <!-- DETAILS -->
          <booking-checkout-iframe-room-slot-pre-cart
            ref="bookingRoomSlotPreCartSummary"
            :location="location"
            :location-child-pricing="locationChildPricing"
            :selected-room-slot="selectedRoomSlot"
            :selected-customer="selectedCustomer"
            :sale-from="saleFrom"
            :add-to-cart-button-disable.sync="disableContinueAfterSelectingCustomer"
            :booking-label-adults="bookingLabelAdults"
            :booking-label-adults-selection="bookingLabelAdultsSelection"
            :booking-child-caveat="bookingChildCaveat"
            :iframe-scroll-transition="iframeScrollTransition"
            :pricing-style="pricingStyle"
            :allow-zero-adults="allowZeroAdults"

            @move-to-room-questions="scrollDomIdIntoView('roomQuestions')"
            @move-to-player-entry="scrollDomIdIntoView('chooseYourTeam')"
            @back-to-calendar="calendarClicked"
            @try-another-room-slot="tryAnotherRoomSlot"
            @get-customer-details="getCustomerDetails"
            @add-room-slot-to-cart="addRoomSlotToCart"></booking-checkout-iframe-room-slot-pre-cart>

          <booking-checkout-iframe-unlock-locked-room-slot
            v-if="unlockingRoomSlot"
            ref="unlockLockedRoomSlot"
            :location="location"
            :locked-room-slot="unlockingRoomSlot"
            @destroy-room-slot-lock="destroyRoomSlotLock"
            @proceed-to-sale-from-locked-room-slot="proceedToSaleFromLockedRoomSlot">
            </booking-checkout-iframe-unlock-locked-room-slot>

          <booking-checkout-iframe-call-to-book
            v-if="callToBookRoomSlot"
            ref="callToBookComponent"
            :location="location"
            :c2b-room-slot="callToBookRoomSlot"
            :show-call-to-book-as-sold="showCallToBookAsSold"
            @try-another-room-slot="tryAnotherRoomSlot"></booking-checkout-iframe-call-to-book>
        </div>

        <div v-show="showCustomer" class="" id="customer" ref="customer">
          <!-- CUSTOMER -->
          <booking-checkout-iframe-customer
            ref="customerComponent"
            :location="location"
            :customer-request-marketing-permission="customerRequestMarketingPermission"
            :location-child-pricing="locationChildPricing"
            :selected-customer="selectedCustomer"
            :show-details="showDetails"
            @back-to-calendar="calendarClicked"
            @back-to-purchase-details="purchaseDetailsClicked"
            @back-to-checkout="paymentClicked"
            @customer-selected="customerSelected"
            @empty-cart="cartEmpty"
            @remove-customer-from-cart="cartRemoveCustomer"
            ></booking-checkout-iframe-customer>

          <div class="tempus-iframe-800-container" v-if="selectedRoomSlot || selectedVoucherRequest">
            <div class="container pb-4">
              <button
                class="btn btn-lg btn-block btn-dark-green"
                :disabled="continueAfterSelectingCustomerDisabled"
                @click="continueAfterSelectingCustomer">Continue</button>
            </div>
          </div>

        </div>

        <div v-show="showPayment" class="" id="payment" ref="payment">
          <!-- PAYMENT -->
          <checkout
            v-if="showCheckout"
            ref="checkout"
            :location="location"
            :initial-cart="cart"
            :customer-request-marketing-permission="customerRequestMarketingPermission"
            :room-slot-lock-length="roomSlotLockLength"
            :booking-fee="bookingFee"
            :feature-voucher="featureVoucher"
            :location-child-pricing="locationChildPricing"
            :location-discount="locationDiscount"
            :default-per-room-deposit="defaultPerRoomDeposit"
            :products="products"
            :room-products="roomProducts"
            :from-iframe="true"
            :pricing-style="pricingStyle"
            :sale-in-progress="saleInProgress"
            :allow-zero-adults="allowZeroAdults"
            @click-calendar-button="calendarClicked"
            @empty-cart="cartEmpty"
            @get-customer-details="getCustomerDetails"
            @checkout-status-empty="checkoutStatusEmpty"
            @cart-updated="cartRefreshed"
            @sale-transaction-received="saleTransactionReceived"
            @sale-updated="saleUpdatedFromCheckout"
            @take-sale-payment="continueSalePayment"
            @vouchers-added-to-sale="vouchersAddedToSale"
            @take-payment="startTakePayment">
          </checkout>

          <pay-handler-iframe
            ref="payHandlerIframe"
            :location="location"
            :show-payment-handler="showPaymentHandler"
            @scroll-to-choose-tabs="scrollToChooseTabs"
            @scroll-to-payment-div="scrollToPayment"
            @payment-process-completed="saleTransactionReceived"/>

        </div>

        <div v-show="showSummary" class="" id="summary" ref="summary">
          <!-- SUMMARY -->
          <checkout-payment-summary
            ref="paymentSummary"
            :location="location"
            :sale-survey-enabled="saleSurveyEnabled"
            :voucher-expiry="voucherExpiry"
            :voucher-auto-email="voucherAutoEmail"
            :sale-survey-strings="saleSurveyStrings"
            :deployment-bg-class="deploymentBgClass"
            ></checkout-payment-summary>
        </div>
      </div>
    </main>
  </div>

</template>

<script>
import {Address} from 'address-rfc2821';

export default {
  props: {
    firstShow: {
      type: String,
      default: 'DEFAULT',
    },
    unfilledLocation: {
      type: Object,
      required: true,
    },
    initialDate: {
      type: String,
      required: true,
    },
    external: {
      type: Boolean,
      default: true,
    },
    saleSurveyStrings: {
      type: Object,
      required: true,
    },
    initialCurrentCartHashId: {
      type: String,
      required: true,
    },
    pricingStyle: {
      type: String,
      default: 'DEFAULT',
    },
    bookingLabelStateLocked: {
      type: String,
      default: 'RESERVED',
    },
    bookingLabelStateBooked: {
      type: String,
      default: 'SOLD',
    },
    brand: {
      type: String,
      default: 'Tempus',
    },
    saleSurveyEnabled: {
      type: Boolean,
      default: false,
    },
    hasMultipleLocations: {
      type: Boolean,
      default: false,
    },
    maxPerRow: {
      type: Number,
      default: 5,
    },
    adultPricingNotPlayerPricing: {
      type: Boolean,
      default: false,
    },
    showCallToBookAsSold: {
      type: Boolean,
      default: false,
    },
    showDuration: {
      type: Boolean,
      default: false,
    },
    showPlayers: {
      type: Boolean,
      default: false,
    },
    customerRequestMarketingPermission: {
      type: Boolean,
      default: false,
    },
    roomSlotLockLength: {
      type: Number,
      default: 15,
    },
    bookingFee: {
      type: Number,
      default: 0,
    },
    featureVoucher: {
      type: Boolean,
      default: false,
    },
    defaultPerRoomDeposit: {
      type: Number,
      default: 5000,
    },
    voucherCalculatorAmounts: {
      type: Array,
      default: [],
    },
    initialPostCutoff: {
      type: String
    },
    voucherAutoEmail: {
      type: Boolean,
      default: false,
    },
    sellPostalVoucher: {
      type: Boolean,
      default: false,
    },
    collectVoucher: {
      type: Boolean,
      default: false,
    },
    voucherUniversal: {
      type: Boolean,
      default: false,
    },
    voucherExpiry: {
      type: Number,
      default: 12,
    },
    bookingLabelAdults: {
      type: String,
      default: 'Adults',
    },
    bookingLabelAdultsSelection: {
      type: String,
      default: 'Select number of adults',
    },
    bookingChildCaveat: {
      type: String,
      default: 'Minimum of 2 adult tickets per game, regardless of age. A child is defined as 15 or younger.',
    },
    useShortRoomName: {
      type: Boolean,
      default: true,
    },
    iframeScrollTransition: {
      type: Boolean,
      default: false,
    },
    initialWeekCalendar: {
      type: String,
      default: 'booking-calendar-sub-component-all-rooms-grid',
    },
    allowZeroAdults: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // to turn all console logs on or off
      consoleDebug: true,

      // former props
      location: Vue.util.extend({}, this.unfilledLocation ? JSON.parse(JSON.stringify(this.unfilledLocation)) : {}),
      locationDiscount: null,
      roomSlots: [],
      roomsAvailable: [],
      locationChildPricing: false,
      products: [],
      roomProducts: [],
      locationVoucherProducts: false,
      postCutoff: moment(this.initialPostCutoff).endOf("day"),
      // /former props

      date: moment(this.initialDate),

      currentCartHashId: JSON.parse(JSON.stringify(this.initialCurrentCartHashId)),
      cart: {},
      sale: {},

      bookingVueComponent: this.firstShow == 'v' ? 'gift-voucher-sub-component' : (this.initialWeekCalendar == 'week-grid' ? 'booking-calendar-sub-component-all-rooms-grid' : this.initialWeekCalendar), // 'booking-calendar-sub-component-all-rooms-cards' 'booking-calendar-sub-component-all-rooms-grid' 'booking-calendar-style-week-grid'

      room: null,
      showRoomCalendarOnLoad: false,

      showCalendar: false,
      showDetails: false,
      showCustomer: false,
      showPayment: false,
      showSummary: false,

      calendarDisabled: true,
      detailsDisabled: true,
      customerDisabled: true,
      paymentDisabled: true,
      summaryDisabled: true,

      itemSelectedForPurchase: false,
      itemConfirmedForPurchase: false,
      customerDetailsPresent: false,

      saleRefreshTimeout: null,
      saleRefreshTimeoutTime: 2500,
      transactionAmountReceived: null,

      discount: null,

      temporaryCart: null,
      disableCartEchoUpdateFlag: false,
      disablePayButton: false,

      customer: {
        email: null,
        name: null,
      },

      locationQuestionsError: null,
      locationQuestionsMinimised: false,

      showPaymentHandler: false,

      showLocationAddOns: true,
      showRoomAddOns: false,
      displayAddOnsAsList: true,

      // for pushing to the pre-Cart
      selectedRoomSlot: null,
      selectedCustomer: null,
      selectedVoucherRequest: null,

      // for unlocking roomSlot
      unlockingRoomSlot: null,

      // for C2B roomSlot
      callToBookRoomSlot: null,

      // for after selection of customer
      checkoutAfterCustomerAdd: false,

      // disabling add to cart in subcomponent and the continue under customer entry
      disableContinueAfterSelectingCustomer: true,

      showHelpDiv: false,

      resizeObserver: null,
      iFrameMoveWait: 100,
    };
  },

  computed: {
    deploymentBgClass() {
      switch (this.$deploymentCurrent) {
        case 'cryptology':
          return 'bg-cryptology-blue';

        case 'breakescape':
          return 'bg-be-background';

        case 'coalville':
          return 'bg-lightest-gray';

        case 'taketheexit':
        case 'paralysis':
        case 'horrorescape':
        case 'escapegoat':
        case 'missionclassified':
        case 'rushden':
        case 'topescaperooms':
        case 'panicroomharlow':
        case 'axefactor':
        case 'escapetime':
        case 'escaporium':
        case 'operationescape':
        case 'oo7escaperooms':
        case 'theescapelounge':
        case 'lakesescapes':
        case 'housetrap':
        case 'funkysnake':
          return 'bg-darkest-gray text-white';

        case 'kanyu':
        case 'beyondbreakout':
        case 'crypticescape':
        case 'escapereading':
        case 'prodigy':
        case 'escapestaging':
        case 'roomescapersboston':
          return 'bg-white text-black';

        case 'wisbech':
          return 'bg-wisbech text-white';

        case 'makeyourescape':
          return '';

        case 'the-real-escape':
          return 'bg-the-real-escape-bg text-white';

        case 'escapable':
          return 'bg-calendar-lighten-opacity text-white';

        case 'bridlington':
          return 'bg-bridlington-lighter text-white';

        case 'cypherquest':
          return 'bg-cypherquest text-white';

        case 'levelup':
          return 'bg-' + this.$deploymentCurrent + ' text-black';

        case 'mythologic':
        case 'ctrlaltesc':
          return 'bg-' + this.$deploymentCurrent + ' text-white';

        case 'cluehqsomerton':
          return 'bg-clue-hq-blue text-white';

        default:
          return 'bg-' + this.$deploymentCurrent;
      }
    },

    showCheckout() {
      // ouch, so many untraceable `Error in render: "TypeError: Cannot read properties of undefined (reading 'length')"` things, when this whole page loads
      // so, making it v-if only if the Cart has some Items, or that there a Sale present should solve this
      if (this.cartOrSale) {
        // this may return an empty cart
        if (this.cartOrSale == 'cart' && this.cart.cart_items && this.cart.cart_items.length == 0) {
          return false;
        }
        return true;
      }
      return false;
    },

    saleFrom() {
      /*
       * PHP LOGIC NEEDS MAKING HERE

        if ($room->exists) {
            $this->room = $room;
            $this->from = Booking::FROM_ROOM_PAGE;
        } else {
            if (is_null($alternativeCalendarType)) {
                $this->from = Booking::FROM_BOOKING_PAGE;
            } elseif ($alternativeCalendarType == 'AXE') {
                $this->from = Booking::FROM_AXE_THROWING;
            } elseif ($alternativeCalendarType == 'TOURS') {
                $this->from = Booking::FROM_TOURS;
            } elseif ($alternativeCalendarType == 'VR') {
                $this->from = Booking::FROM_VR;
            } elseif ($alternativeCalendarType == 'RAGE') {
                $this->from = Booking::FROM_RAGE_ROOM;
            } elseif ($alternativeCalendarType == 'PAINT') {
                $this->from = Booking::FROM_PAINT_ROOM;
            } elseif ($alternativeCalendarType == 'SLOTCAR') {
                $this->from = Booking::FROM_SLOT_CAR_ROOM;
            } else {
                // fallback
                $this->from = Booking::FROM_BOOKING_PAGE;
            }
        }

    public const FROM_BOOKING_PAGE = 'A';
    public const FROM_ROOM_PAGE = 'R';
    public const FROM_DASH = 'D';
    public const FROM_TEMPUS = 'T';
    public const FROM_AXE_THROWING = 'X';
    public const FROM_TOURS = 'W'; // tours = [W]alls
    public const FROM_VR = 'V';
    public const FROM_RAGE_ROOM = 'G';
    public const FROM_PAINT_ROOM = 'P';
    public const FROM_SLOT_CAR_ROOM = 'S';
    public const RESOVA_IMPORT = 'I';
    public const BOOKEO_IMPORT = 'B';

       */
      return 'A';
    },

    cartOrSale() {
      if (Object.keys(this.cart).length && ! Object.keys(this.sale).length) {
        return 'cart';
      } else if (Object.keys(this.sale).length) {
        return 'sale';
      }
      return null;
    },

    cartInProgress() {
      if (this.cartOrSale == 'cart' && this.cart && this.cart.cart_items.length > 0) {
        return true;
      }
      return false;
    },

    saleInProgress() {
      if (this.cartOrSale == 'sale' && this.sale.sale_items.length > 0 && this.sale.left_to_pay != 0) {
        return true;
      }
      return false;
    },

    inPromo() {
      if (this.locationDiscount) {
        if (moment().isBetween(moment(this.locationDiscount.valid_from), moment(this.locationDiscount.expiry))) {
          return true;
        }
      }
      return false;
    },

    isDiscounted() {
      // inPromo should only apply to Carts, as as soon as a LocationDiscount is used on a Cart, it is added as a Discount to the Sale
      if (this.cartOrSale == 'cart') {
        if (this.cart.discountDetails && this.cart.discountDetails.amount && this.cart.discountDetails.amount > 0) {
          return true;
        }
        if (this.inPromo) {
          return true;
        }
      } else if (this.cartOrSale == 'sale') {
        if (this.sale.discountedAmount) {
          return true;
        } else if (this.sale.discounts.length) {
          return true;
        }
      }
      return false;
    },

    discountedAmount() {
      if (this.cartOrSale == 'sale') {
        return parseInt(this.sale.discountedAmount);
      }

      if (this.inPromo) {
        return parseInt(this.cart.price * (this.locationDiscount.percentage / 100));
      }
      if (this.isDiscounted) {
        return parseInt(this.cart.discountDetails.amount);
      }
      return 0;
    },

    discountedTotal() {
      if (this.cartOrSale == 'cart') {
        return parseInt(this.cart.price - this.discountedAmount);
      }
      return parseInt(this.sale.total_amount);
    },

    discountDescription() {
      if (this.isDiscounted) {
        if (this.cartOrSale == 'cart'
          && this.cart.discountDetails
          && this.cart.discountDetails.amount
          && this.cart.discountDetails.amount > 0) {
          return this.cart.discountDetails.description;
        } else if ((this.cartOrSale == 'sale' && this.sale.discount_description)
          || (this.cartOrSale == 'sale' && this.sale.discounts.length)) {
          return this.sale.discount_description ? this.sale.discount_description : this.sale.discounts[0].description;
        } else if (this.locationDiscount) {
          return this.locationDiscount.description;
        }
      }
      return null;
    },

    voucherWorth() {
      if (this.voucher) {
        if (this.voucher.type == 'M') {
          return this.voucher.amount;
        } else if (this.voucher.type == 'O') {
          return this.location.prices.find(price => price.price_for == this.voucher.amount).offpeak
        } else {
          return this.location.prices.find(price => price.price_for == this.voucher.amount).peak
        }
      }

      return 0;
    },

    fromPbl() {
      if (this.cartOrSale == 'cart') {
        return false;
      }
      return this.sale.options && this.sale.options.pbl_expiry;
    },

    saleDeletable() {
      if (this.cartOrSale == 'cart') {
        // nonsense!
        return false;
      } else if (this.sale.transactions.length > 0) {
        return false;
      } else if (this.fromPbl) {
        return false;
      }

      return true;
    },

    depositable() {
      if (this.cartOrSale == 'cart') {
        return false;
      }
      // the rules for this are as follows

      if (this.sale.transactions.length == 0) {
        // is it from a PBL?
        if (this.fromPbl) {
          return true;
          // use the deposit amount that is set
          // if deposit amount is null, use the Meta default
        }

        // if the default depositable amount is very close to the full amount, don't let it happen
        if (this.sale.total_amount * 0.8 < this.depositAmount) {
          return false;
        }

        // this SaleCheckout, if not a PBL, can only be got to via the unlocking of a previous attempt
        // usually this happens from a failed amount, so a deposit is offered
        // this now has a Meta|Option setting
        return this.allowRetryDeposit;
      }

      if (this.sale.totalTransactionsAmount == 0) {
        // to allow for an accidental FOC or a PayOnArrival
        return true;
      }

      // there is already at least 1 transaction, do not allow a deposit
      return false;
    },

    discountable() {
      if (! this.inPromo && this.discountedAmount) {
        return false;
      }

      if (this.cartOrSale == 'sale' && this.sale.totalTransactionsAmount) {
        return false;
      }

      return true;
    },

    // discountDescription() {
    //   if (this.discount) {
    //     return this.discount.description;
    //   }

    //   return this.sale.discount_description;
    // },

    depositAmount() {
      if (this.cartOrSale == 'cart') {
        return 99999;
      }
      if (this.sale.deposit_amount) {
        return this.sale.deposit_amount;
      }
      return this.sale.sale_items.filter(si => si.saleable_type == 'App\\Models\\Booking').length * this.defaultPerRoomDeposit;
    },

    headerClass() {
      return '';

      var theClass = '';
      switch (this.$deploymentCurrent) {
        case 'cryptology':
        case 'm4escapes':
        theClass = 'bg-lt-maze text-black';
          break;

        case 'taketheexit':
        theClass = 'mt-4';
          break;

        default:
          break;
      }

      return theClass;
    },

    roomQuestions() {
      return this.location.rooms.filter(r => r.room_questions.length)
        .reduce((map, obj) => {
          map[obj.id] = obj.room_questions;

          return map;
        }, {});
    },

    roomsPresent() {
      if (this.cartOrSale == 'cart') {
        return this.cart.cart_items.filter(ci => ci.cartable_type == 'App\\Models\\RoomSlot').map(ci => ci.cartable.room_id);
      }

      return this.sale.sale_items.filter(si => si.cartable_type == 'App\\Models\\Booking').map(si => si.saleable.room_slot.room_id);
    },

    roomQuestionsRequired() {
      var num = 0;
      this.roomsPresent.forEach(room_id => {
        if (this.roomQuestions[room_id]) {
          num += this.roomQuestions[room_id].filter(rq => rq.required).length;
        }
      });
      return num;
    },

    requiredRoomQuestionsAnswered() {
      var num = 0;
      if (this.cartOrSale == 'cart') {
        this.cart.cart_items.forEach(ci => {
          if (ci.cart_item_question_responses) {
            num += ci.cart_item_question_responses.filter(ciqr => ciqr.questionable.required && (ciqr.response != null && ciqr.response != 0 && ciqr.response != '')).length;
          }
        });
      } else {
        this.sale.sale_items.forEach(si => {
          if (si.cart_item_question_responses) {
            num += si.sale_item_question_responses.filter(siqr => siqr.questionable.required && (siqr.response != null && siqr.response != 0 && siqr.response != '')).length;
          }
        });
      }

      return num;
    },

    locationQuestionsRequired() {
      return this.location.location_questions.filter(lq => lq.required);
    },

    requiredLocationQuestionsAnswered() {
      if (this.cartOrSale == 'cart') {
        return this.cart.cart_question_responses.filter(cqr => cqr.questionable.required).filter(cqr => {
          if (cqr.questionable.type == 'CHECKBOX') {
            if (cqr.response == 0 || cqr.response === null) {
              return false;
            } else {
              return true;
            }
          } else if (cqr.questionable.type == 'RADIO' && cqr.response === null) {
            return false;
          } else if (cqr.response == '' || cqr.response == null) {
            return false;
          }
          return true;
        });
      } else {
        return this.sale.sale_question_responses.filter(sqr => sqr.questionable.required).filter(sqr => {
          if (sqr.questionable.type == 'CHECKBOX') {
            if (sqr.response == 0 || sqr.response === null) {
              return false;
            } else {
              return true;
            }
          } else if (sqr.questionable.type == 'RADIO' && sqr.response === null) {
            return false;
          } else if (sqr.response == '' || sqr.response == null) {
            return false;
          }
          return true;
        });
      }
    },

    sortedItems() {
      if (this.cartOrSale == 'cart') {
        if (this.cart.cart_items.length) {
          // we want the RoomSlots always at the top, so let's sort these first
          let sortedRoomSlotItems = this.cart.cart_items
            .filter(ci => ci.cartable_type == 'App\\Models\\RoomSlot')
            .sort((a, b) => moment(a.cartable.start) - moment(b.cartable.start));

          let otherItems = this.cart.cart_items
            .filter(ci => ci.cartable_type != 'App\\Models\\RoomSlot' && ci.cartable_type != 'App\\Models\\Product');

          let addOnItems = this.cart.cart_items
            .filter(ci =>
              ci.cartable_type == 'App\\Models\\Product'
              && (ci.options == null || typeof(ci.options.for_room_slot_ids) == 'undefined')
            );

          return [...sortedRoomSlotItems, ...otherItems, ...addOnItems];
        }
      } else {
        if (this.sale.sale_items.length) {
          // we want the RoomSlots always at the top, so let's sort these first
          let sortedRoomSlotItems = this.sale.sale_items
            .filter(si => si.saleable_type == 'App\\Models\\Booking')
            .sort((a, b) => moment(a.saleable.room_slot.start) - moment(b.saleable.room_slot.start));

          let otherItems = this.sale.sale_items
            .filter(si => si.saleable_type != 'App\\Models\\Booking' && si.saleable_type != 'App\\Models\\Product');

          let addOnItems = this.sale.sale_items
            .filter(si =>
              si.saleable_type == 'App\\Models\\Product'
              && (si.options == null || typeof(si.options.for_room_slot_id) == 'undefined')
            );

          return [...sortedRoomSlotItems, ...otherItems, ...addOnItems];
        }
      }

      return [];
    },

    visibleAddOns() {
      if (this.showRoomAddOns === false) {
        return this.products;
      }

      // now we need to add Room Add-ons, the correct way
      // TODO: Fix add for each roomslot not just each room
      var roomProducts = [];
      this.roomProducts.forEach(roomProduct => {
        roomProduct.rooms.forEach(room => {
          if (! room.pivot.visible) {
            return;
          }

          if (this.roomsPresent.includes(room.id)) {
            let addOn = JSON.parse(JSON.stringify(roomProduct));
            addOn.for_room = room;
            roomProducts.push(addOn);
          }
        });
      });

      return [...this.products, ...roomProducts];
    },

    continueAfterSelectingCustomerDisabled() {
      if (! this.selectedCustomer) {
        return true;
      }
      if (this.selectedRoomSlot && this.disableContinueAfterSelectingCustomer) {
        return true;
      }
      return false;
    },

    openRooms() {
      if (this.location.prices) {
        return this.location.rooms.filter(room => room.badge != 'SOON');
      }
      return [];
    },
  },

  watch: {
    bookingVueComponent(newBookingVueComponent, oldBookingVueComponent) {
      if (newBookingVueComponent != oldBookingVueComponent) {
        this.showCalendar = true;
      }
      if (newBookingVueComponent == 'gift-voucher-sub-component') {
        this.selectedRoomSlot = null;
        this.detailsDisabled = true;
        this.showDetails = false;
      }
    },

    cart(newCart, oldCart) {
      if (Object.keys(newCart).length !== 0 && newCart.cart_items.length > 0) {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::WATCH-cart IF');
        this.itemSelectedForPurchase = true;
        this.itemConfirmedForPurchase = true;
        if (this.selectedRoomSlot === null) {
          this.detailsDisabled = true;
        }
      }
      // else if (true) {
      //   console.log('!!! watch cart has now fired on the ELSE');
      //   console.log('!!! watch cart newCart', newCart);
      //   console.log('!!! watch cart this.sale', this.sale, typeof(this.sale.id));
      // }
    },

    sale(newSale, oldSale) {
      if (Object.keys(newSale).length !== 0 && newSale.sale_items.length > 0) {
        this.itemSelectedForPurchase = true;
        this.itemConfirmedForPurchase = true;
      }
    },

    selectedCustomer(newSelectedCustomer, oldSelectedCustomer) {
      if (this.consoleDebug) console.log('WATCH selectedCustomer', newSelectedCustomer);
      if (newSelectedCustomer && newSelectedCustomer.id) {
        this.customerDetailsPresent = true;
      }
    },
  },

  methods: {
    /*
     * These are header methods for this new iFrame, some were started pre-concept, and all need checking to see if they are still relevant
     *
     * 1)  inIframe()
     * 2)  onlyShow()
     * 3)  requiresIframeScrollFix()
     * 4)  scrollToChooseTabs()
     * 5)  scrollToTop()
     * 6)  scrollDomIdIntoView(id)
     * 7)  scrollDomIdIntoViewCenter(id)
     * 8)  scrollDomIdIntoViewEnd(id)
     * 9)  calendarClicked()
     * 10) purchaseDetailsClicked()
     * 11) customerClicked()
     * 12) paymentClicked()
     * 13) summaryClicked()
     * 14) showRoomCalendar(room)
     * 15) roomDropdownClicked()
     * 16) changeQueryString(param, value)
     * 17) checkSaleIsPresentAndChangeUrlParams()
     * 18) resetAllInputsAndVariables()
     * 19) init()
     * 20) initGetParams()
     * 21) dateChanged(newDate)
     * 22) resetDomToBeginning()
     * 23) updateCartAndSale(cart, sale);
     *
     */

    inIframe() {
      // (https://stackoverflow.com/questions/326069/)
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },

    onlyShow(variable) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::onlyShow', variable);

      // first set everything to not-visible
      this.showCalendar = false;
      this.showDetails = false;
      this.showCustomer = false;
      this.showPayment = false;
      this.showSummary = false;

      this[variable] = true;

      if (variable == 'showCalendar') {
        if (Object.keys(this.cart).length !== 0 && this.cart.cart_items.length > 0) {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::onlyShow[showCalendar] - if Object TRUE');
          // do nothing, there are items in the cart
        } else {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::onlyShow[showCalendar] - if Object FALSE');
          // TODO: more ifs are required, but this is likely clicking on stuff as the item is not added to cart yet
          this.itemSelectedForPurchase = false;
        }
      } else if (variable == 'showPayment') {
        this.scrollToChooseTabs();
      }
    },

    requiresIframeScrollFix() {
      // https://stackoverflow.com/questions/54603497/cross-domain-iframe-element-scrollintoview-safari-issue

      try {
        // Debug navigator Agent
        if (this.consoleDebug) console.log(navigator.userAgent);

        // We know this issue happens inside an IFrame on;
        // Safari iPhone
        // Safari iPad
        // Safari Desktop Works fine.

        // Check for safari
        var is_safari = navigator.userAgent.indexOf("Safari") > -1;
        // Chrome has Safari in the user agent so we need to filter (https://stackoverflow.com/a/7768006/1502448)
        var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
        if ((is_chrome) && (is_safari)) { is_safari = false; }

        // If we need to narrow this down even further we can use a more robust browser detection (https://stackoverflow.com/questions/5916900)
        // Problematic browsers can be adjusted here.
        if (is_safari && this.inIframe() && (
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/iPhone/i)
        )) {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::requiresIframeScrollFix IS TRUE');
          return true;
        } else {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::requiresIframeScrollFix IS FALSE');
          return false;
        }
      } catch (e) {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::requiresIframeScrollFix - catch');
        if (this.consoleDebug) console.log(e.message);
      }

      return false;
    },

    scrollToChooseTabs() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToChooseTabs');

      this.scrollDomIdIntoView('chooseTabs');
      return;

      if (this.external === false) {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToChooseTabs - requiresIframeScrollFix() is not being called && external === TRUE - therefore need to Check Cryptology on a Mac!', this.$refs.chooseTabs.getBoundingClientRect().top);

        const elm = document.getElementById('chooseTabs');
        elm.scrollIntoView({ behavior: 'instant', block: 'start',}); // If not scroll into view as usual.

        // window.scrollTo({ top: this.$refs.chooseTabs.getBoundingClientRect().top, behavior: 'smooth' });
      } else {
        if (this.requiresIframeScrollFix()) {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToChooseTabs - requiresIframeScrollFix() is true && external === false');
          setTimeout(() => {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToChooseTabs - timeout is over, should have scrolled to the top');
            window.scrollTo({ top: this.$refs.thisMainDiv.getBoundingClientRect().top, behavior: 'smooth' });
            // window.top.postMessage(['move', this.$refs.chooseTabs.getBoundingClientRect().top], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
          }, 1000)
        } else {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToChooseTabs - requiresIframeScrollFix() is FALSE && external === false');
          setTimeout(() => {
            window.scrollTo({ top: this.$refs.thisMainDiv.getBoundingClientRect().top, behavior: 'smooth' });
            // window.top.postMessage(['move', this.$refs.chooseTabs.getBoundingClientRect().top], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
          }, 200)
        }
      }
    },

    scrollToTop() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToTop');
      if (this.external === false) {
        // is not being used as an iFrame, therefore move the better way
        window.scrollTo({ top: this.$refs.thisMainDiv.getBoundingClientRect().top, behavior: 'smooth' });
      } else {
        if (this.requiresIframeScrollFix()) {
          if (this.consoleDebug) console.log('scrollToTop requiresIframeScrollFix is true');
          window.top.postMessage(['move', 0], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
        } else {
          if (this.consoleDebug) console.log('scrollToTop requiresIframeScrollFix is false');
          setTimeout(() => {
            window.top.postMessage(['moveSmooth', 0], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
          }, 200)
        }
      }
    },

    scrollDomIdIntoView(id) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomIdIntoView', id);
      // https://stackoverflow.com/questions/54603497/cross-domain-iframe-element-scrollintoview-safari-issue
      this.$nextTick(() => {
        const elm = document.getElementById(id);

        if (this.external === false) {
          // elm.scrollIntoView({ behavior: 'smooth', block: 'start',}); // If not scroll into view as usual.

          const yOffset = -80; // tested for Cryptology because of the navbar, and only for 'move-to-player-entry' / 'chooseYourTeam'
          window.scrollTo({top: elm.getBoundingClientRect().top + window.scrollY + yOffset, behavior: 'smooth' });
        } else {
          if (this.requiresIframeScrollFix()) {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomIdIntoView - requiresIframeScrollFix is true', elm.getBoundingClientRect().top);
            window.top.postMessage(['movePlus', elm.getBoundingClientRect().top], "*");
          } else {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomIdIntoView requiresIframeScrollFix is false', elm.getBoundingClientRect().top);
            setTimeout(() => {
              window.top.postMessage(['movePlus', elm.getBoundingClientRect().top], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
            }, 100)
          }
        }
      });
    },

    scrollDomIdIntoViewCenter(id) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomIdIntoViewCenter', id);
      this.$nextTick(() => {
        const elm = document.getElementById(id);

        if (this.external === false) {
          // is not being used as an iFrame, therefore move the better way
          elm.scrollIntoView({ behavior: 'smooth', block: 'center',}); // If not scroll into view as usual.
        } else {
          if (this.requiresIframeScrollFix()) {
            window.top.postMessage(['move', parseInt((elm.getBoundingClientRect().top + elm.getBoundingClientRect().bottom)/2)], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
          } else {
            setTimeout(() => {
              elm.scrollIntoView({ behavior: 'smooth', block: 'center',}); // If not scroll into view as usual.
            }, 100);
          }
        }
      });
    },

    scrollDomIdIntoViewEnd(id) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomIdIntoViewEnd', id);
      this.$nextTick(() => {
        const elm = document.getElementById(id);

        if (this.external === false) {
          // is not being used as an iFrame, therefore move the better way
          elm.scrollIntoView({ behavior: 'smooth', block: 'end',}); // If not scroll into view as usual.
        } else {
          if (this.requiresIframeScrollFix()) {
            window.top.postMessage(['move', elm.getBoundingClientRect().bottom], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
          } else {
            setTimeout(() => {
              elm.scrollIntoView({ behavior: 'smooth', block: 'end',}); // If not scroll into view as usual.
            }, 100);
          }
        }
      });
    },

    scrollDomToPrecise(y, yOffest = 0) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomToPrecise', y, yOffest);
      this.$nextTick(() => {
        if (this.external === false) {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomToPrecise - external === false');
          // is not being used as an iFrame, therefore move the better way
          window.scrollTo({top: (parseInt(y) + parseInt(yOffest)), behavior: 'smooth'});
        } else {
          if (this.requiresIframeScrollFix()) {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomToPrecise - requiresIframeScrollFix');
            window.top.postMessage(['movePlus', (parseInt(y) + parseInt(yOffest) + 100)], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
          } else {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollDomToPrecise - ! requiresIframeScrollFix');
            window.top.postMessage(['movePlus', (parseInt(y) + parseInt(yOffest))], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
          }
        }
      });
    },

    calendarClicked() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::calendarClicked');
      if (this.bookingVueComponent == null) {
        this.bookingVueComponent = this.initialWeekCalendar;
      }
      this.showCalendar = true;
      if (this.iframeScrollTransition) {
        this.scrollDomIdIntoView('calendar');
      } else {
        this.onlyShow('showCalendar');
        this.scrollToChooseTabs();
      }
    },
    purchaseDetailsClicked() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::purchaseDetailsClicked');

      if (this.iframeScrollTransition) {
        this.scrollDomIdIntoViewEnd('details');
      } else {
        this.onlyShow('showDetails');
      }
    },
    customerClicked() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::customerClicked');

      if (this.iframeScrollTransition) {
        this.scrollDomIdIntoView('customer');
      } else {
        this.onlyShow('showCustomer');
      }
    },
    paymentClicked() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::paymentClicked');

      if (this.iframeScrollTransition) {
        this.scrollDomIdIntoView('payment');
      } else {
        this.onlyShow('showPayment');
      }
    },
    summaryClicked() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::summaryClicked');

      if (this.iframeScrollTransition) {
        this.scrollDomIdIntoView('summary');
      } else {
        this.onlyShow('showSummary');
      }
    },

    showRoomCalendarConfirm(room, event) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::showRoomCalendarConfirm', room, event);

      if (this.saleInProgress) {
        // do nothing
        flash('A Sale is in progress, disallowed', 'danger');
        return false;
      }

      // the first check here is to see if a sale has just happened, because if so, we need to ensure that all sale and cart bits are fully reset
      if (this.showSummary) {
        const self = this;
        // confirmation popover
        let options = {
          container: 'body',
          rootSelector: event.target,
          title: 'Confirm New Sale',
          content: 'Confirming this will remove all payments and summary details, and will start a new cart for a new sale. Confirmation Email(s) should have been sent, but this will remove the confirmation here. Are you sure?',
          popout: true,
          singleton: true,
          btnOkClass: 'btn btn-sm btn-success',
          btnCancelClass: 'btn btn-sm btn-outline-dark',
          trigger: 'manual',
          onConfirm(type) {
            self.$nextTick(function () {
              self.resetAllInputsAndVariables();
              self.showRoomCalendar(room);
            });
          },
        };

        $(event.target).confirmation('dispose');
        $(event.target).confirmation(options);
        $(event.target).confirmation('show');

      } else {
        this.showRoomCalendar(room);
      }
    },

    showRoomCalendar(room) {
      this.scrollToChooseTabs();

      if (this.iframeScrollTransition) {
        this.scrollDomIdIntoView('calendar');
      } else {
        this.onlyShow('showCalendar');
      }

      if (room === null) {
        // this is passed from the Room Calendar to go back to the all-rooms calendar
        this.bookingVueComponent = this.initialWeekCalendar;
      } else {
        if (room == 'VOUCHERS') {
          // nothing to do
          return;
        }
        if (room != 'booking-calendar-sub-component-virtual-games') {
          this.room = room;
          this.bookingVueComponent = 'booking-calendar-sub-component-room-week-grid';
        }

        if (room) { // TODO: need the logic here for Axe Throwing and the other variants
          this.axeThrowing = false;
        } else {
          this.axeThrowing = false;
        }
      }

      if (this.roomSlots.length == 0) {
        this.$nextTick(() => {
          this.$refs.bookingCalendarComponent.fetchRoomSlots();
        });
      }
    },

    roomDropdownClicked() {
      if (this.saleInProgress) {
        // do nothing
      } else {
        this.showCalendar = true;
        $('.dropdown-toggle').dropdown();
      }
    },

    changeQueryString(param, value) {
      let url = new URL(window.location);
      let params = new URLSearchParams(url.search);
      params.set(param, value);
      history.replaceState({}, '', `${location.pathname}?${params}`);
    },

    async checkSaleIsPresentAndChangeUrlParams() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::checkSaleIsPresentAndChangeUrlParams');
      let url = new URL(window.location);
      let params = new URLSearchParams(url.search);

      if (params.has('salehash')) {
        // salehash is present, it needs checking if we have one
        if (this.consoleDebug) console.log('BookingCheckoutIframe::checkSaleIsPresentAndChangeUrlParams - await');
        await this.refreshSaleFromHash(params.get('salehash'));
        if (this.consoleDebug) console.log('BookingCheckoutIframe::checkSaleIsPresentAndChangeUrlParams - DONE awaiting');
        if (Object.keys(this.sale).length === 0 || (this.sale.transactions.length && this.sale.left_to_pay == 0)) {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::checkSaleIsPresentAndChangeUrlParams - SALE TO BE REMOVED');
          params.delete('salehash');
          history.replaceState({}, '', `${location.pathname}?${params}`);
          this.resetDomToBeginning();
          this.sale = {};
        } else {
          this.continueSalePayment();
        }
      }
    },

    resetAllInputsAndVariables() {
      this.sale = {};
      this.$refs.bookingRoomSlotPreCartSummary.resetBookModalInputs();
    },

    async init() {
      // this is Vue, it cannot load the variables from passed variables through the controller
      // so the first thing to do is to obtain them, and then Tempus can begin

      // if (this.consoleDebug) console.log('BookingCheckoutIframe::init');
      const paramsGot = await this.initGetParams();
      // if (this.consoleDebug) console.log('BookingCheckoutIframe::init - paramsGot', paramsGot);
      if (paramsGot) {
        // if (this.consoleDebug) console.log('BookingCheckoutIframe::init - params have been got');
        this.showCalendar = true;
        this.calendarDisabled = false;
        this.checkSaleIsPresentAndChangeUrlParams();
        this.checkCartIsPresentAndHasItems();
        if (this.firstShow != 'v') {
          this.$nextTick(() => {
            this.$refs.bookingCalendarComponent.fetchRoomSlots();
          });
        }
      } else {
        console.log('BookingCheckoutIframe::init - ERROR - params have not been got');
      }
    },

    initGetParams() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::initGetParams');
      return new Promise(resolve => {
        let request = {
          dt: this.date,
        }

        this.loading(true);

        axios.get(this.route('api.locations.iframe-parameters', this.unfilledLocation), {params: request})
          .then((response) => {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::initGetParams - axios completed', response.data);
            this.loading(false);

            if (response.status == 200) {
              // flash('Init params loaded','success');

              this.location = response.data.location;
              this.locationDiscount = response.data.locationDiscount == 'null' ? null : response.data.locationDiscount;
              this.locationChildPricing = response.data.locationChildPricing == 'true' ? true : false;
              this.products = response.data.products;
              this.roomProducts = response.data.roomProducts;
              this.locationVoucherProducts = response.data.locationVoucherProducts;

              if (this.showRoomCalendarOnLoad) {
                let room = this.location.rooms.find(r => r.id == this.showRoomCalendarOnLoad);
                if (room) {
                  this.showRoomCalendar(room);
                  this.showRoomCalendarOnLoad = false;
                }
              }
              resolve(true);
            } else {
              flash('Error getting Location Params', 'error');
              console.log('initGetParams', response.data);
              console.log('initGetParams', response.status);
              console.log('initGetParams', response.statusText);
              resolve(false);
            }

        })
        .catch((error) => {
          flash('Error getting Location Params', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('initGetParams:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('initGetParams:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('initGetParams:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('initGetParams:401', error.response.data);
            } else {
              console.log('initGetParams: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('initGetParams: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('initGetParams: Error', error.message);
          }
          this.loading(false);
        });
      });
    },

    dateChanged(newDate) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::dateChanged', newDate);
      this.date = newDate
    },

    resetDomToBeginning() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::resetDomToBeginning');
      // this method has been created because we can hit an empty, or cartItem-less Cart in more than one way
      // and we want to avoid giving a blank screen with little input
      // it is always assumed that this Cart has no CartItems, but it does not assume that their is not an assigned Customer
      // (there could be)

      // however this will get fired when a sale starts, so we do not want to interrupt that!

      this.itemSelectedForPurchase = false;
      this.itemConfirmedForPurchase = false;
      this.detailsDisabled = true;
      if (this.consoleDebug) console.log('BookingCheckoutIframe::resetDomToBeginning about to calendarClicked()');
      this.calendarClicked();
    },

    updateCartAndSale(cart, sale, fromFunction) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::updateCartAndSale', 'called from: ' + fromFunction, cart, sale);
      // this function has been created because when both Cart and Sale are updated in one go, we may want to display the calendar, or checkout.
      // Doing this with watchers doesn't quite work, so we want to do this manually here.

      this.sale = sale;
      this.cart = cart;
    },

    /*
     * =====================================
     * End of new methods
     */

    /*
     * CART Methods
     *
     * 1)  refreshCart()
     * 2)  addVoucherProductToSelected(roomSlot)
     * 3)  addRoomSlotToPreCart(roomSlot)
     * 4)  addRoomSlotToCart(roomSlot)
     * 5)  continueAfterSelectingCustomer()
     * 6)  goToCheckout()
     * 7)  checkCartIsPresentAndHasItems()
     * 8)  cartRefreshed(cart)
     * 9)  pushCartToChildren(cart)
     * 10) cartEmpty()
     * 11) cartRemoveCustomer()
     *
     */

    refreshCart(andPushToChildren = false) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshCart', andPushToChildren);

      return new Promise(resolve => {
        let request = {
          location_id: this.location.id,
        };

        axios.get(this.route('api.cart.show', this.currentCartHashId), {params: request})
          .then((response) => {
            if (response.status == 200) {
              if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshCart - axios back', response.data);
              this.cart = response.data;
              if (andPushToChildren) {
                if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshCart - about to pushCartToChildren');

                this.pushCartToChildren(this.cart);
              }
              resolve(true);
            } else {
              flash('Error refreshing Cart', 'danger');
              console.log('refreshCart', response.data);
              console.log('refreshCart', response.status);
              console.log('refreshCart', response.statusText);
              resolve(false);
            }
          })
          .catch((error) => {
            flash('Error fetching RoomSlots for day', 'danger');
            if (error.response) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              // else if HTTP_CONFLICT
              // else if HTTP_FORBIDDEN on enough permissions
              if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                console.log('refreshCart:401', error.response.data);
              }
              console.log('refreshCart: Response error', error.response.data, error.response.status, error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('refreshCart: Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('refreshCart: Error', error.message);
            }
            this.loading(false);
            resolve(false);
          });
      });
    }, // refreshCart()

    addVoucherRequestToSelected(voucherRequestObject) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::addVoucherProductToSelected', voucherRequestObject);
      this.detailsDisabled = false;
      this.showDetails = true;
      this.itemSelectedForPurchase = true;
      if (this.selectedCustomer) {
        this.customerDisabled = false;
        this.showCustomer = true;
      }

      this.selectedVoucherRequest = voucherRequestObject.request;
      this.checkoutAfterCustomerAdd = voucherRequestObject.checkoutAfterAdd;
      if (this.consoleDebug) console.log('BookingCheckoutIframe::addVoucherProductToSelected - this.selectedVoucherRequest is set', this.selectedVoucherRequest);

      this.$nextTick(() => {
        if (this.iframeScrollTransition) {
          this.scrollDomIdIntoViewCenter('details');
        } else {
          this.onlyShow('showDetails');
        }
      });
    },

    addRoomSlotToPreCart(roomSlot) {
      // this is triggered when a RoomSlot is clicked on the calendar
      // so, it needs to go to the details section, and the screen moved here

      if (this.consoleDebug) console.log('BookingCheckoutIframe::addRoomSlotToPreCart', roomSlot);
      this.unlockingRoomSlot = null;
      this.callToBookRoomSlot = null;
      this.detailsDisabled = false;
      this.showDetails = true;
      if (this.selectedCustomer) {
        this.customerDisabled = false;
        this.showCustomer = true;
      }
      this.bookingVueComponent = null;

      this.selectedRoomSlot = roomSlot;

      this.$nextTick(() => {
        // 2025-04-07 - MT, not sure at this point that the viewport needs changing at all
        //
        // if (this.iframeScrollTransition) {
        //   this.scrollDomIdIntoViewCenter('preCart');
        // } else {
        //   this.itemSelectedForPurchase = true;
        //   this.onlyShow('showDetails');
        //   this.scrollToChooseTabs();
        // }
      });
    },

    addVoucherToCart() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::addVoucherToCart', this.checkoutAfterCustomerAdd);

      this.loading(true);
      axios.post(this.route('api.cart.cart-items.store', this.currentCartHashId), this.selectedVoucherRequest)
        .then((response) => {
          // if (this.consoleDebug) console.log('api.cart.cart-items.store axios completed');
          if (response.status == 200) {
            if (this.consoleDebug) console.log('this.cart updated', response.data);
            this.cart = response.data;

            flash('Voucher added to Cart.','warning');

            this.showPayment = true;
            this.paymentDisabled = false;

            this.$nextTick(() => {
              this.selectedVoucherRequest = null;
              if (this.checkoutAfterCustomerAdd) {
                if (this.consoleDebug) console.log('this.checkoutAfterCustomerAdd is true');

                if (this.iframeScrollTransition) {
                  this.scrollDomIdIntoViewCenter('payment');
                } else {
                  this.onlyShow('showPayment');
                }
              } else {
                if (this.consoleDebug) console.log('this.checkoutAfterCustomerAdd is false');
                if (this.iframeScrollTransition) {
                  this.scrollDomIdIntoViewCenter('voucherSale');
                } else {
                  this.calendarClicked();
                }
              }
            });
          } else {
            flash('Error adding Voucher to Cart', 'error');
            console.log('addVoucherToCart', response.data);
            console.log('addVoucherToCart', response.status);
            console.log('addVoucherToCart', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error adding Voucher to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('addVoucherToCart:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('addVoucherToCart:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('addVoucherToCart:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('addVoucherToCart:401', error.response.data);
            } else {
              console.log('addVoucherToCart: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('addVoucherToCart: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('addVoucherToCart: Error', error.message);
          }

          this.loading(false);
        });
    }, // addVoucherToCart()

    addRoomSlotToCart(requestObject) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::addRoomSlotToCart', requestObject, this.checkoutAfterCustomerAdd);
      this.checkoutAfterCustomerAdd = requestObject.checkoutAfterAdd;

      // console.log('api.cart.cart-items.store', request);

      // let's just get the loading on the calendar
      this.loading(true);
      axios.post(this.route('api.cart.cart-items.store', this.currentCartHashId), requestObject.request)
        .then((response) => {
          // console.log('api.cart.cart-items.store axios completed');
          if (response.status == 200) {
            // console.log('this.cart updated', response.data);
            this.cart = response.data;
            this.pushCartToChildren(this.cart);

            // this.roomQuestionResponses = {};
            // this.roomQuestionResponseErrors = null;
            // this.roomQuestionResponseError = {};

            // flash('RoomSlot added to Cart.','warning');

            this.showPayment = true;
            this.paymentDisabled = false;

            this.$nextTick(() => {
              this.selectedRoomSlot = null;
              if (this.checkoutAfterCustomerAdd) {
                if (this.consoleDebug) console.log('BookingCheckoutIframe::addRoomSlotToCart - this.checkoutAfterCustomerAdd is TRUE');
                if (this.iframeScrollTransition) {
                  this.scrollDomIdIntoViewCenter('payment');
                } else {
                  this.onlyShow('showPayment');
                }
              } else {
                if (this.consoleDebug) console.log('BookingCheckoutIframe::addRoomSlotToCart - this.checkoutAfterCustomerAdd is FALSE');
                if (this.consoleDebug) console.log('BookingCheckoutIframe::addRoomSlotToCart about to calendarClicked()');
                this.calendarClicked();
                if (this.iframeScrollTransition) {
                  this.scrollDomIdIntoViewCenter('cartSummaryHeader');
                } else {
                  this.scrollToChooseTabs();
                }
              }
            });
          } else {
            flash('Error adding RoomSlot to Cart', 'error');
            console.log('addRoomSlotToCart', response.data);
            console.log('addRoomSlotToCart', response.status);
            console.log('addRoomSlotToCart', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error adding RoomSlot to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('addRoomSlotToCart:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('addRoomSlotToCart:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('addRoomSlotToCart:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('addRoomSlotToCart:401', error.response.data);
            } else {
              console.log('addRoomSlotToCart: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('addRoomSlotToCart: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('addRoomSlotToCart: Error', error.message);
          }

          this.loading(false);
        });
    }, // addRoomSlotToCart

    publishRoomSlots(roomSlots) {
      // console.log('BookingCheckoutIframe::publishRoomSlots', roomSlots);
      this.roomSlots = roomSlots;
    },
    publishRoomsAvailable(roomsAvailable) {
      // console.log('BookingCheckoutIframe::publishRoomsAvailable', roomsAvailable);
      this.roomsAvailable = roomsAvailable;
    },

    continueAfterSelectingCustomer() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::continueAfterSelectingCustomer', this.checkoutAfterCustomerAdd);
      // we now have a Customer Selected, so we can continue with adding to the cart, now the Cart can have a customer
      if (this.selectedRoomSlot) {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::continueAfterSelectingCustomer | selectedRoomSlot', this.selectedRoomSlot);
        this.$refs.bookingRoomSlotPreCartSummary.addToCartButtonClicked(this.checkoutAfterCustomerAdd);
      } else if (this.selectedVoucherRequest) {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::continueAfterSelectingCustomer | selectedVoucherRequest', this.selectedVoucherRequest);
        this.addVoucherToCart({checkoutAfterAdd: this.checkoutAfterCustomerAdd});
      } else {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::continueAfterSelectingCustomer !!!UNKNOWN!!!!');
      }
    },

    goToCheckout() {
      if (this.iframeScrollTransition) {
        this.scrollDomIdIntoViewCenter('payment');
      } else {
        this.onlyShow('showPayment');
      }
    },

    async checkCartIsPresentAndHasItems() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::checkCartIsPresentAndHasItems');

      const cartGot = await this.refreshCart();

      if (this.consoleDebug) console.log('BookingCheckoutIframe::checkCartIsPresentAndHasItems - cart now awaited and complete');

      // when the iFrame loads, the Cart may have items in there, and if so, we need to ensure that some of the links in the header work
      if (this.cart && this.cart.cart_items && this.cart.cart_items.length) {
        this.showDetails = true;
        this.showCustomer = true;
        this.showPayment = true;
        this.detailsDisabled = false;
        this.customerDisabled = false;
        this.paymentDisabled = false;
        this.pushCartToChildren(this.cart);
      } else if (this.cart && this.cart.customer && this.cart.customer.id) {
        // ok, but we can have an empty cart with a customer added, so need to handle this too
        this.showCustomer = true;
        this.customerDisabled = false;
        this.pushCartToChildren(this.cart);
      }
    },

    cartRefreshed(cart) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::cartRefreshed', cart);
      this.cart = cart;
    }, // cartRefreshed()

    pushCartToChildren(cart) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::pushCartToChildren(cart)', cart);

      if (cart.customer && cart.customer.id) {
        this.selectedCustomer = JSON.parse(JSON.stringify(cart.customer));
      }
      this.$refs.customerComponent.cartRefreshed(cart);
    },

    cartEmpty() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::cartEmpty()');

      let request = {
        location: this.location.slug,
      }

      this.loading(true);

      axios.delete(this.route('api.cart.destroy', this.currentCartHashId), {data: request})
        .then((response) => {
          if (response.status == 200) {
            this.cart = response.data;
            this.currentCartHashId = this.cart.hashid;
            this.pushCartToChildren(this.cart);
            this.customerDetailsPresent = false;
            this.itemConfirmedForPurchase = false;
            this.calendarClicked();

          } else {
            flash('Error emptying Cart', 'danger');
            console.log('cartEmpty', response.data);
            console.log('cartEmpty', response.status);
            console.log('cartEmpty', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          flash('Error emptying Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartEmpty:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartEmpty:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartEmpty:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartEmpty:401', error.response.data);
            } else {
              console.log('cartEmpty: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartEmpty: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartEmpty: Error', error.message);
          }
          this.loading(false);
        });
    },

    cartRemoveCustomer() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::cartRemoveCustomer');

      var request = {
        customer_id: null,
      };

      this.loading(true);
      axios.patch(this.route('api.cart.update', this.currentCartHashId), request)
        .then((response) => {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::cartRemoveCustomer - axios completed', response.data);
          this.loading(false);

          if (response.status == 200) {
            // console.log('this.cart updated', response.data);
            this.cart = response.data;
            this.pushCartToChildren(this.cart);
            this.customerDetailsPresent = false;

            if (this.consoleDebug) console.log('BookingCheckoutIframe::cartRemoveCustomer about to calendarClicked()');
            this.calendarClicked();

          } else {
            flash('Error removing Customer to Cart', 'error');
            console.log('cartRemoveCustomer', response.data);
            console.log('cartRemoveCustomer', response.status);
            console.log('cartRemoveCustomer', response.statusText);
          }

        })
        .catch((error) => {
          flash('Error removing RoomSlot to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartRemoveCustomer:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartRemoveCustomer:409', error.response.data);
              flash(error.response.data.message, 'danger');
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartRemoveCustomer:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartRemoveCustomer:401', error.response.data);
            } else {
              console.log('cartRemoveCustomer: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartRemoveCustomer: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartRemoveCustomer: Error', error.message);
          }
          this.loading(false);
        });
    },

    /*
     * =====================================
     * End of CART methods
     */

    /*
     * SALE Methods
     *
     * 1) saleRefreshed(sale)
     * 2) pushSaleToChildren(sale)
     * 3) refreshSaleFromHash(hashid)
     * 4) refreshSale(sale, activateOrDeactiveSummaryAfterFetch = false)
     * 5) redeemVouchersForSale(vouchersToRedeem)
     *
     */

    saleRefreshed(sale) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::saleRefreshed', sale);
      this.sale = sale;
    }, // saleRefreshed()

    pushSaleToChildren(sale) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::pushSaleToChildren(sale)', sale);
      this.$refs.checkout.saleRefreshed(sale);
      this.$refs.payHandlerIframe.saleRefreshed(sale);
      this.$refs.paymentSummary.saleRefreshed(sale);
      this.$refs.customerComponent.saleRefreshed(sale);
    },

    refreshSaleFromHash(hashid) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshSaleFromHash');

      return new Promise(resolve => {
        axios.get(this.route('api.sales.public-show', hashid))
          .then((response) => {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshSaleFromHash axios: response.data', response.data)
            if (response.status == 200) {
              this.sale = response.data;

              resolve(true);

            } else {
              flash('Error refreshing Sale', 'danger');
              console.log('refreshSaleFromHash', response.data);
              console.log('refreshSaleFromHash', response.status);
              console.log('refreshSaleFromHash', response.statusText);
              resolve(false);
            }
          })
          .catch((error) => {
            // flash('Error refreshing Sale', 'danger');  // no longer want this to reflect to the user, this failing is okay and 404 gracefully handles this
            if (error.response) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              // else if HTTP_CONFLICT
              // else if HTTP_FORBIDDEN on enough permissions
              if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                // flash('Error refreshing Sale (401)', 'danger');
                console.log('BookingCheckoutIframe::refreshSaleFromHash:401', error.response.data);
              }
              else if (error.response.status == 404) {
                // 404 not found
                console.log('BookingCheckoutIframe::refreshSaleFromHash - Sale not found');
              }
              console.log('refreshSaleFromHash: Response error', error.response.data, error.response.status, error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('refreshSaleFromHash: Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('refreshSaleFromHash: Error', error.message);
            }

            resolve(false);
          });
      });
    },

    refreshSale(sale, activateOrDeactiveSummaryAfterFetch = false) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshSale', sale, activateOrDeactiveSummaryAfterFetch);
      if (this.consoleDebug) console.log('BookingCheckoutIframe:: this.saleRefreshTimeout', this.saleRefreshTimeout);

      if (this.saleRefreshTimeout) {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshSale - this.saleRefreshTimeout already exists, therefore do nothing');
        if (this.consoleDebug) console.log('!!!!!!!!!!');
        if (this.consoleDebug) console.log('This is a dirty way to bail from this, MT would rather find out WHY this is being called than have this in here');
        return;
      }

      this.loading(true);
      // this.loading(true, this.$refs.payment);

      // TODO: I have added a this.saleRefreshTimeout delay, due to some background processes that can fire slower than this code picks things up.
      // this should be handled better, probably with echo?

      this.saleRefreshTimeout = setTimeout(() => {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshSale - this.saleRefreshTimeout = setTimeout(() wait over and code is now commencing');
        axios.get(this.route('api.sales.public-show', sale))
          .then((response) => {
            // if (this.consoleDebug) console.log('refreshSale axios: response.status', response.status)
            if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshSale axios: response.data', response.data)
            if (response.status == 200) {
              // flash('Sale refreshed', 'success');
              this.sale = response.data;
              if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshSale axios function - about to push data to children')
              this.pushSaleToChildren(response.data)

              // we have now updated the sale
              // we need to check if we have taken a transaction amount
              if (this.transactionAmountReceived !== null) {
                this.sendTransactionToTaggers(response.data.id);
              }

              if (activateOrDeactiveSummaryAfterFetch) {
                if (this.consoleDebug) console.log('BookingCheckoutIframe::refreshSale axios - activateOrDeactiveSummaryAfterFetch', activateOrDeactiveSummaryAfterFetch);

                if (sale.left_to_pay == 0) {
                  this.showPaymentHandler = false;
                }
                this.summaryDisabled = false;
                this.showSummary = true;
                this.scrollToChooseTabs();
              }
            } else {
              flash('Error refreshing Sale', 'danger');
              console.log('refreshSale', response.data);
              console.log('refreshSale', response.status);
              console.log('refreshSale', response.statusText);
            }

            this.loading(false);
          })
          .catch((error) => {
            // flash('Error refreshing Sale', 'danger');  // no longer want this to reflect to the user, this failing is okay and 404 gracefully handles this
            if (error.response) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              // else if HTTP_CONFLICT
              // else if HTTP_FORBIDDEN on enough permissions
              if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                flash('Error refreshing Sale (401)', 'danger');
                console.log('refreshSale:401', error.response.data);

              }
              else if (error.response.status == 404) {
                // 404 not found
                console.log('BookingCheckoutIframe::refreshSale - Sale not found');
                this.sale = {};
                this.pushSaleToChildren({});
                this.showPayment = false;
                this.showSummary = false;
                this.showPaymentHandler = false;
              }
              console.log('refreshSale: Response error', error.response.data, error.response.status, error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('refreshSale: Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('refreshSale: Error', error.message);
            }

            this.loading(false);
          });
      }, this.saleRefreshTimeoutTime);
    }, // end of refreshSale

    redeemVouchersForSale(vouchersToRedeem) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::redeemVouchersForSale', vouchersToRedeem);

      var voucherTransactions = [];
      vouchersToRedeem.forEach(voucher => {
        voucherTransactions.push({
          amount: voucher.cashValue,
          booked_by: 'W',
          cart_reference: voucher.reference,  // don't change this or everything will break
          from: 'C', // checkout
          transaction_reference: null,
          transaction_type_id: 15,
        });
      });

      let request = {
        transactions: voucherTransactions,
      };

      axios.post(this.route('api.sales.transactions.store', this.sale.hashid), request)
        .then((response) => {
          if (response.status == 200) {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::redeemVouchersForSale axios back', response.data);
            this.saleTransactionReceived();

          } else {
            flash('Error submitting new Transactions', 'danger');
            console.log('redeemVouchersForSale::voucher', response.data);
            console.log('redeemVouchersForSale::voucher', response.status);
            console.log('redeemVouchersForSale::voucher', response.statusText);
          }

        })
        .catch((error) => {
          flash('Error processing Voucher', 'danger');
          if (error.response) {
            // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
            if (error.response.status == 422) {
              console.log('redeemVouchersForSale::voucher -  laravel validation error', error.response.data);
            }
            // else if HTTP_CONFLICT to many saleables or over lap
            else if (error.response.status == 409) {
              this.lockError = error.response.data;
            }
            // else if HTTP_FORBIDDEN on enough permissions
            else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('redeemVouchersForSale::voucher - 401', error.response.data);
            }
            else {
              console.log('redeemVouchersForSale::voucher - Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('redeemVouchersForSale::voucher - Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('redeemVouchersForSale::voucher - Error', error.message);
          }
        });
    },

    discountBookingInFull(discount) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::discountBookingInFull', discount);

      let request = {
        discount_id: discount.id,
      }

      this.loading(true);

      axios.post(this.route('api.sales.discount.store', this.sale), request)
        .then((response) => {
          if (response.status == 200) {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::discountBookingInFull axios response is:', response.data);

         } else {
            flash('Error adding Discount to Cart', 'danger');
            console.log('discountBookingInFull:addDiscountToSale', response.data);
            console.log('discountBookingInFull:addDiscountToSale', response.status);
            console.log('discountBookingInFull:addDiscountToSale', response.statusText);
          }

          let txRequest = {
            transactions: [{
              amount: 0,
              booked_by: 'W',
              cart_reference: 'FOC',
              from: 'C', // checkout
              transaction_reference: null,
              transaction_type_id: 10, // gratis
            }],
          };

          axios.post(this.route('api.sales.transactions.store', this.sale.hashid), txRequest)
            .then((response) => {
              if (response.status == 200) {
                if (this.consoleDebug) console.log('BookingCheckoutIframe::discountBookingInFull transaction axios back', response.data);

                this.saleTransactionReceived();

              } else {
                flash('Error submitting new Transactions', 'danger');
                console.log('discountBookingInFull::tx axios', response.data);
                console.log('discountBookingInFull::tx axios', response.status);
                console.log('discountBookingInFull::tx axios', response.statusText);
              }

              this.loading(false);
            })
            .catch((error) => {
              this.loading(false);
              flash('Error processing Voucher', 'danger');
              if (error.response) {
                // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
                if (error.response.status == 422) {
                  console.log('discountBookingInFull::tx axios -  laravel validation error', error.response.data);
                }
                // else if HTTP_CONFLICT to many saleables or over lap
                else if (error.response.status == 409) {
                  this.lockError = error.response.data;
                }
                // else if HTTP_FORBIDDEN on enough permissions
                else if (error.response.status == 401) {
                  // else if HTTP_UNAUTHORIZED not authorized
                  console.log('discountBookingInFull::tx axios - 401', error.response.data);
                }
                else {
                  console.log('discountBookingInFull::tx axios - Response error', error.response.data, error.response.status, error.response.headers);
                }
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error('discountBookingInFull::tx axios - Request error', error.request);
              } else {
                // Something happened in setting up the request that triggered an Error
                console.error('discountBookingInFull::tx axios - Error', error.message);
              }
            });
        })
        .catch((error) => {
          flash('Error adding Discount to Cart', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('discountBookingInFull:addDiscountToSale:422', error.response.data);
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('discountBookingInFull:addDiscountToSale:409', error.response.data);
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('discountBookingInFull:addDiscountToSale:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('discountBookingInFull:addDiscountToSale:401', error.response.data);
            } else {
              console.log('discountBookingInFull:addDiscountToSale: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('discountBookingInFull:addDiscountToSale: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('discountBookingInFull:addDiscountToSale: Error', error.message);
          }
          this.loading(false);
        });

    }, // discountBookingInFull()

    /*
     * =====================================
     * End of SALE methods
     */

    /*
     * ROOMSLOT Methods
     *
     * 1) showCallToBook(roomSlot)
     * 2) attemptToUnlockSlot(roomSlot)
     * 3) destroyRoomSlotLock(roomSlotEmailObject)
     * 4) proceedToSaleFromLockedRoomSlot(roomSlotEmailObject)
     * 5) tryAnotherRoomSlot()
     *
     */

    showCallToBook(roomSlot) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::showCallToBook', roomSlot);
      this.showDetails = true;
      this.callToBookRoomSlot = roomSlot;
      this.$nextTick(() => {
        this.scrollDomIdIntoViewCenter('details');
      });
    },

    attemptToUnlockSlot(roomSlot) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::attemptToUnlockSlot', roomSlot);
      this.selectedRoomSlot = null;
      this.callToBookRoomSlot = null;
      this.unlockingRoomSlot = roomSlot;

      this.detailsDisabled = false;
      this.showDetails = true;

      this.$nextTick(() => {
        this.scrollDomIdIntoViewCenter('details');
      });
    },

    destroyRoomSlotLock(roomSlotEmailObject) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::destroyRoomSlotLock', roomSlotEmailObject);

      let request = {
        email: roomSlotEmailObject.email,
      }

      // send this.lockEmail and check if it the person who has the pending booking
      this.loading(true);

      axios.patch(this.route('api.room-slot-locks.check-and-destroy', roomSlotEmailObject.roomSlot.activeRoomSlotLock), request)
        .then((response) => {
          this.loading(false);

          if (response.status == 200) {
            let destroyLockResponse = response.data;
            if (this.consoleDebug) console.log('BookingCheckoutIframe::destroyRoomSlotLock axios response destroyLockResponse', destroyLockResponse)
            flash('This lock has been removed', 'success');

            // BookingCalendar will refresh due to the change in state of the RoomSlot

            this.unlockingRoomSlot = null;
            if (this.iframeScrollTransition) {
              this.scrollDomIdIntoViewCenter('calendar');
            } else {
              this.scrollToChooseTabs();
            }

            // we now need to find out if the Sale/Cart still exists
            if (this.consoleDebug) console.log('now going to check that the sale is there');
            if (this.sale && Object.keys(this.sale).length !== 0) {
              if (this.consoleDebug) console.log('sale is checked and present, therefore refreshSale')
              this.refreshSale(this.sale);
            }

          } else {
            flash('Error destroying RoomSlotLock', 'error');
            console.log('destroyRoomSlotLock', response.data);
            console.log('destroyRoomSlotLock', response.status);
            console.log('destroyRoomSlotLock', response.statusText);
          }
        })
        .catch((error) => {
          flash('That email does not match the locked booking.', 'danger');
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('destroyRoomSlotLock:422', error.response.data);
              if (this.unlockingRoomSlot) {
                this.$refs.unlockLockedRoomSlot.populateLockError('That email does not match the locked booking. Please supply the correct email or choose another slot.');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('destroyRoomSlotLock:409', error.response.data);
              this.asPendingError = 'Sorry this slot is no longer available, please pick another slot.';
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('destroyRoomSlotLock:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('destroyRoomSlotLock:401', error.response.data);

            } else {
              console.log('destroyRoomSlotLock: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('destroyRoomSlotLock: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('destroyRoomSlotLock: Error', error.message);
          }

          this.loading(false);
        }); // axios
    }, // destroyRoomSlotLock

    proceedToSaleFromLockedRoomSlot(roomSlotEmailObject) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::proceedToSaleFromLockedRoomSlot', roomSlotEmailObject);

      let request = {
        email: roomSlotEmailObject.email,
      }

      this.loading(true);

      // returned data will come from api\RoomSlotController::continueBookingFromLock
      // and it will have a response either
      // LOCKED
      // 'state' => 'LOCKED',
      // 'roomSlot' => $roomSlot
      //
      // or
      //
      // 'state' => 'BOOKED_PENDING',
      // 'sale' => $booking->sale,

      axios.patch(this.route('api.room-slots.continue-booking', roomSlotEmailObject.roomSlot), request)
        .then((response) => {
          this.loading(false);

          if (response.status == 200) {
            // console.log('lockProceedResponse', roomSlot)
            let returnedData = response.data;

            if (returnedData.state == "BOOKED_PENDING") {
              console.log('returnedData.state == "BOOKED_PENDING"', returnedData)
              this.showPayment = true;
              this.sale = returnedData.sale;
              this.selectedCustomer = returnedData.sale.customer;
              this.$nextTick(() => {
                this.$refs.checkout.saleRefreshed(this.sale);
                this.changeQueryString('salehash', this.sale.hashid);
                this.paymentDisabled = false;
                this.selectedRoomSlot = null;
                this.$nextTick(() => {
                  if (this.iframeScrollTransition) {
                    this.scrollDomIdIntoViewCenter('payment');
                  } else {
                    this.onlyShow('showPayment');
                  }
                });
              });
            } else if (returnedData.state == "LOCKED") {
              console.log('returnedData.state == "LOCKED"')

              let selectedRoomSlot = returnedData.roomSlot;
              this.selectedCustomer = returnedData.customer;

              // TODO: proceed with pre-cart
            }
          } else {
            flash('Error continuing proceedToSaleFromLockedRoomSlot', 'error');
            console.log('proceedToSaleFromLockedRoomSlot', response.data);
            console.log('proceedToSaleFromLockedRoomSlot', response.status);
            console.log('proceedToSaleFromLockedRoomSlot', response.statusText);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('proceedToSaleFromLockedRoomSlot:422', error.response.data);
              if (this.unlockingRoomSlot) {
                this.$refs.unlockLockedRoomSlot.populateLockError('That email does not match the locked booking. Please supply the correct email or choose another slot.');
              }
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('proceedToSaleFromLockedRoomSlot:409', error.response.data);
              this.asPendingError = 'Sorry this slot is no longer available, please pick another slot.';
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('proceedToSaleFromLockedRoomSlot:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('proceedToSaleFromLockedRoomSlot:401', error.response.data);
            } else {
              console.log('proceedToSaleFromLockedRoomSlot: Response error', error.response.data, error.response.status, error.response.headers);
              flash('That email does not match the locked booking.', 'danger');
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('proceedToSaleFromLockedRoomSlot: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('proceedToSaleFromLockedRoomSlot: Error', error);
          }

          this.loading(false);
        }); // axios
    }, // proceedToSaleFromLockedRoomSlot

    tryAnotherRoomSlot() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::tryAnotherRoomSlot');
      this.showDetails = false;
      this.callToBookRoomSlot = null;
      this.selectedRoomSlot = null;
      this.calendarClicked();
    },

    /*
     * =====================================
     * End of ROOMSLOT methods
     */

    /*
     * CUSTOMER Methods
     *
     * 1) getCustomerDetails(checkoutAfterAdd)
     * 2) customerSelected(customer)
     * 3) addCustomerToCart()
     */

    getCustomerDetails(checkoutAfterAdd = true) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::getCustomerDetails', checkoutAfterAdd);

      // what if there is already a customer? <-- MT 2024-12-28 think this is already handled

      this.customerDisabled = false;
      this.showCustomer = true;
      this.bookingVueComponent = null;
      this.itemConfirmedForPurchase = true;

      this.checkoutAfterCustomerAdd = checkoutAfterAdd;

      this.$nextTick(() => {
        if (this.iframeScrollTransition) {
          this.scrollDomIdIntoViewCenter('customer');
        } else {
          this.onlyShow('showCustomer');
          // if (this.external === false) {
          //   var yOffset = -200;
          // } else {
          //   var yOffset = 100;
          // }
          this.$nextTick(() => {
            this.scrollDomIdIntoView('customer');

            // const yOffset = 0;
            // const y = document.getElementById('customer').getBoundingClientRect().top + window.scrollY + yOffset;
            // this.scrollDomToPrecise(y);
          });
        }
      });
    }, // getCustomerDetails()

    customerSelected(customer) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::customerSelected', customer);
      this.selectedCustomer = customer;
      if (this.consoleDebug) console.log('BookingCheckoutIframe::customerSelected - this.selectedCustomer now populated');
      this.addCustomerToCart()
        .then(() => {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::customerSelected - addCustomerToCart just returned');
          this.continueAfterSelectingCustomer();
        });
    },

    async addCustomerToCart() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::addCustomerToCart');
      if (! this.selectedCustomer || (this.selectedCustomer && this.selectedCustomer.id === null)) {
        if (this.consoleDebug) console.log('addCustomerToCart BAILED');
        return false
      }
      return new Promise(resolve => {
        let request = {
          location: this.location.slug,
          customer_id: this.selectedCustomer.id,
        }

        this.loading(true);
        axios.patch(this.route('api.cart.update', this.currentCartHashId), request)
          .then((response) => {
            if (this.consoleDebug) console.log('BookingCheckoutIframe::addCustomerToCart - addCustomerToCart axios completed', response.data);
            this.loading(false);

            if (response.status == 200) {
              // console.log('this.cart updated', response.data);
              this.cart = response.data;
              this.pushCartToChildren(this.cart);

              // flash('Added you as the Cart owner','success');
              resolve(true);
            } else {
              flash('Error adding Customer to Cart', 'error');
              console.log('addCustomerToCart', response.data);
              console.log('addCustomerToCart', response.status);
              console.log('addCustomerToCart', response.statusText);
              resolve(false);
            }

          })
          .catch((error) => {
            flash('Error adding RoomSlot to Cart', 'danger');
            if (error.response) {
              if (error.response.status == 422) {
                // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
                console.log('addCustomerToCart:422', error.response.data);
                if (error.response.data.errors) {
                  const errors = error.response.data.errors;

                  Object.keys(errors).forEach(function(key) {
                    errors[key].forEach(error => flash(error, 'danger'));
                  });
                } else {
                  flash(error.response.data, 'danger');
                }
              } else if (error.response.status == 409) {
                // else if HTTP_CONFLICT
                console.log('addCustomerToCart:409', error.response.data);
                flash(error.response.data.message, 'danger');
              } else if (error.response.status == 403) {
                // else if HTTP_FORBIDDEN on enough permissions
                console.log('addCustomerToCart:403', error.response.data);
              } else if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                console.log('addCustomerToCart:401', error.response.data);

              } else {
                console.log('addCustomerToCart: Response error', error.response.data, error.response.status, error.response.headers);
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('addCustomerToCart: Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('addCustomerToCart: Error', error.message);
            }
            this.loading(false);
            this.payButtonDisable = false;
            resolve(false);
          });
      });
    },

    /*
     * =====================================
     * End of CUSTOMER methods
     */

    /*
     * CHECKOUT/PAYMENT Methods
     *
     * 1) checkoutStatusEmpty()
     * 2) continueSalePayment()
     * 3) vouchersAddedToSale()
     * 4) locationAndRoomQuestionsCheckPassed()
     * 5) startTakePayment()
     * 6) saleTransactionReceived()
     * 7) saleUpdatedFromCheckout(sale)
     * 8) takePaymentSale(useVoucher = false, deposit = false)
     * 9) takePaymentCart(useVoucher = false, deposit = false)
     *
     */

    checkoutStatusEmpty() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::checkoutStatusEmpty');

      this.detailsDisabled = true;
      this.customerDisabled = true;
      this.paymentDisabled = true;
      this.showCalendar = false;
      this.showDetails = false;
      this.showCustomer = false;
      this.showPayment = false;

      if (Object.keys(this.sale).length === 0 && this.cart && this.cart.cart_items.length == 0) {
        // we have an emptied cart, so, need to start again
        this.showCalendar = true;
        this.$nextTick(() => {
          if (this.iframeScrollTransition) {
            this.scrollDomIdIntoViewCenter('calendar');
          } else {
            this.onlyShow('showCalendar');
            this.scrollToChooseTabs();
          }
        });
      } else {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::checkoutStatusEmpty this should denote the sale is complete and we are about to redirect to the success portion');
        this.$nextTick(() => {
          if (this.iframeScrollTransition) {
            this.scrollDomIdIntoViewCenter('summary');
          } else {
            this.onlyShow('showSummary');
          }
        });
      }
    },

    continueSalePayment(vouchersToRedeem) {
      // only used for Sales
      // used on load of page if salehash is set
      if (this.consoleDebug) console.log('BookingCheckoutIframe::continueSalePayment()', this.sale);

      // because this is now the sale, (for now at least) we do not want them to be able to add anything more, so the calendar should be hidden
      this.showCalendar = false;
      this.calendarDisabled = true;

      if (this.selectedCustomer === null) {
        this.selectedCustomer = this.sale.customer;
      }

      this.showPayment = true;
      this.showPaymentHandler = true;
      this.$refs.checkout.saleRefreshed(this.sale); // checkout needs this variable

      this.$nextTick(() => {
        if (vouchersToRedeem && this.sale.left_to_pay == vouchersToRedeem.reduce((partialSum, v) => partialSum + v.cashValue, 0)) {
          // the supplied voucher(s) equals what is left to pay, so we need to just redeem these
          this.redeemVouchersForSale(vouchersToRedeem);
        } else {
          this.$refs.payHandlerIframe.takeSalePayment(this.sale, vouchersToRedeem, false); // false = deposit flag, this needs to be revised
        }
      });
    },

    vouchersAddedToSale(vouchersToSpend) {
      // when a voucher code is added to Checkout, we need to adjust the amount to pay
      if (this.consoleDebug) console.log('BookingCheckoutIframe::vouchersAddedToSale()', vouchersToSpend);
      this.$refs.payHandlerIframe.addVouchersToSale(vouchersToSpend); // payHandlerIframe needs this array
    },

    locationAndRoomQuestionsCheckPassed() {
      this.locationQuestionsError = null;

      if (this.locationQuestionsRequired.length != this.requiredLocationQuestionsAnswered.length) {
        this.locationQuestionsError = 'Location Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');

        return false;
      }

      if (this.roomQuestionsRequired != this.requiredRoomQuestionsAnswered) {
        this.locationQuestionsError = 'Room Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');

        return false;
      }

      this.locationQuestionsError = null;
      return true;
    },

    startTakePayment(voucherDiscountObject = null) {
      // only used for Carts
      if (this.consoleDebug) console.log('BookingCheckoutIframe::startTakePayment()', voucherDiscountObject);
      var deposit = false;

      // need to check that Room and Location Questions have been answered
      if (this.locationAndRoomQuestionsCheckPassed() === false) {
        // flash already flashed
        return false;
      }

      let request = {
        location: this.location.slug,
        customer_id: this.cart.customer.id,
        discount_id: this.discount ? this.discount.id : null,
        // notes: this.cartNotes, // ??
      }

      this.disableCartEchoUpdate();

      this.loading(true);

      axios.patch(this.route('api.cart.checkout', this.currentCartHashId), request)
        .then((response) => {
          if (this.consoleDebug) console.log('BookingCheckoutIframe - api.cart.checkout response back from axios', response);
          if (this.consoleDebug) console.log('BookingCheckoutIframe - api.cart.checkout response status back from axios', response.status);
          if (response.status == 200) {
            flash('Cart converted to Sale', 'success');

            this.updateCartAndSale(response.data.cart, response.data.sale, 'startTakePayment');
            this.currentCartHashId = response.data.cart.hashid;

            this.$refs.checkout.saleRefreshed(response.data.sale); // checkout needs this variable
            this.$refs.customerComponent.saleRefreshed(response.data.sale); // customerComponent needs this variable
            this.changeQueryString('salehash', response.data.sale.hashid);

            this.showPaymentHandler = true;

            if (this.consoleDebug) console.log('BookingCheckoutIframe - startTakePayment() completed', response.data.sale);
            this.saleUrl = response.data.sale.payment_url;

            // this.refreshCart(true);

            // this.disablePayButton = true;
            this.$nextTick(() => {
              if (voucherDiscountObject && voucherDiscountObject.vouchersToSpend.length && response.data.sale.left_to_pay == voucherDiscountObject.vouchersToSpend.reduce((partialSum, v) => partialSum + v.cashValue, 0)) {
                // the supplied voucher(s) equals what is left to pay, so we need to just redeem these
                this.redeemVouchersForSale(voucherDiscountObject.vouchersToRedeem);
              } else if (voucherDiscountObject && voucherDiscountObject.discount && voucherDiscountObject.discount.percentage == 100
                 || voucherDiscountObject && voucherDiscountObject.discount && voucherDiscountObject.discount.amount && voucherDiscountObject.discount.amount == response.data.sale.left_to_pay) {
                this.discountBookingInFull(voucherDiscountObject.discount);
              } else {
                this.$refs.payHandlerIframe.takeSalePayment(response.data.sale, voucherDiscountObject, deposit === true ? true : false);
              }
            });

          } else {
            this.enableCartEchoUpdate();

            flash('Error with Cart checkout', 'danger');
            console.log('cartCheckout', response.data);
            console.log('cartCheckout', response.status);
            console.log('cartCheckout', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          this.enableCartEchoUpdate();

          let showError = true;

          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartCheckout:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409 && error.response.data.message == 'Blocklist email') {
              // else if HTTP_CONFLICT && Blocklist Email

              $(this.$refs.loadingModal).modal('show');
              showError = false;
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartCheckout:409', error.response.data);
              this.locationQuestionsError = error.response.data.message;
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartCheckout:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartCheckout:401', error.response.data);

            } else {
              console.log('cartCheckout: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartCheckout: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartCheckout: Error', error.message);
          }

          this.loading(false);

          if (showError) {
            flash('Error with Cart checkout', 'danger');
            console.log('error.response', error.response)
          }
        });
    },

    saleTransactionReceived(txAmount = null) {
      // a payment has happened, so we need to fetch the Sale, and see if Checkout has anything left to do.
      if (this.consoleDebug) console.log('BookingCheckoutIframe::saleTransactionReceived this.sale (id|left_to_pay) at this point', this.sale.id, this.sale.left_to_pay);

      if (txAmount) {
        this.transactionAmountReceived = txAmount;
      }

      this.refreshSale(this.sale, true); // true for doing stuff with the summary after fetching
      if (this.consoleDebug) console.log('BookingCheckoutIframe::saleTransactionReceived refreshSale has now been called');


    },

    saleUpdatedFromCheckout(sale) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::saleUpdatedFromCheckout', sale);

      this.sale = sale;
      this.pushSaleToChildren(sale);
    },

    takePaymentSale(useVoucher = false, deposit = false) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::takePaymentSale', useVoucher, deposit);

      this.locationQuestionsError = null;

      if (this.locationQuestionsRequired.length != this.requiredLocationQuestionsAnswered.length) {
        this.locationQuestionsError = 'Location Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');
        return false;
      }

      if (this.roomQuestionsRequired != this.requiredRoomQuestionsAnswered) {
        this.locationQuestionsError = 'Room Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');
        return false;
      }

      if (useVoucher) {
        // console.log('about to useVoucher');
        let voucherTransaction = {
          amount: this.voucherWorth,
          booked_by: 'W',
          cart_reference: this.voucher.reference,  // don't change this or everything will break
          from: 'C', // checkout
          transaction_reference: null,
          transaction_type_id: 15,
        }

        let request = {
          transactions: {voucherTransaction},
        };

        axios.post(this.route('api.sales.transactions.store', this.sale.hashid), request)
          .then((response) => {
            if (response.status == 200) {
              if (response.data.left_to_pay == 0) {
                window.location.href = this.route('location.payment.success', [this.location, response.data]);
              } else {
                window.location.href = response.data.customerRedirect;
              }

            } else {
              flash('Error submitting new Transactions', 'danger');
              console.log('takePaymentSale::voucher', response.data);
              console.log('takePaymentSale::voucher', response.status);
              console.log('takePaymentSale::voucher', response.statusText);
            }

            this.loading(false);
          })
          .catch((error) => {
            flash('Error processing Voucher', 'danger');
            if (error.response) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              if (error.response.status == 422) {
                console.log('takePaymentSale::voucher -  laravel validation error', error.response.data);
              }
              // else if HTTP_CONFLICT to many saleables or over lap
              else if (error.response.status == 409) {
                this.lockError = error.response.data;
              }
              // else if HTTP_FORBIDDEN on enough permissions
              else if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                console.log('takePaymentSale::voucher - 401', error.response.data);

              }
              else {
                console.log('takePaymentSale::voucher - Response error', error.response.data, error.response.status, error.response.headers);
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('takePaymentSale::voucher - Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('takePaymentSale::voucher - Error', error.message);
            }
            this.loading(false);
          });
      } else {
        // console.log('about to send to payment provider');
        this.$refs.payComponent.takeSalePayment(this.sale, null, deposit);
      }
    }, // takePaymentSale

    takePaymentCart(useVoucher = false, deposit = false) {
      // only used for Carts
      // console.log('takePaymentCart', useVoucher, deposit);

      // need to check that Room and Location Questions have been answered
      this.locationQuestionsError = null;

      if (this.locationQuestionsRequired.length != this.requiredLocationQuestionsAnswered.length) {
        this.locationQuestionsError = 'Location Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');

        return false;
      }

      if (this.roomQuestionsRequired != this.requiredRoomQuestionsAnswered) {
        this.locationQuestionsError = 'Room Question(s) still require answering';
        flash(this.locationQuestionsError, 'danger');

        return false;
      }

      let request = {
        location: this.location.slug,
        customer_id: this.cart.customer.id,
        // notes: this.cartNotes, // ??
        discount_id: this.discount ? this.discount.id : null,
      }

      this.locationQuestionsError = null;
      this.loading(true);
      this.disableCartEchoUpdate();
      axios.patch(this.route('api.cart.checkout', this.currentCartHashId), request)
        .then((response) => {
          // console.log('response back from axios', response);
          // console.log('response status back from axios', response.status);
          if (response.status == 200) {
            this.sale = response.data;

            // console.log('cartCheckout() completed', response.data);
            this.saleUrl = response.data.payment_url;

            flash('Cart converted to Sale', 'success');

            this.$nextTick(() => {
              if (useVoucher === true) {
                let voucherTransaction = {
                  amount: this.voucherWorth,
                  booked_by: 'W',
                  cart_reference: this.voucher.reference,  // don't change this or everything will break
                  from: 'C',
                  transaction_reference: null,
                  transaction_type_id: 15,
                }

                let request = {
                  transactions: {voucherTransaction},
                };

                axios.post(this.route('api.sales.transactions.store', this.sale.hashid), request)
                  .then((response) => {
                    if (response.status == 200) {
                      if (response.data.left_to_pay == 0) {
                        window.location.href = this.route('location.payment.success', [this.location, response.data]);
                      } else {
                        window.location.href = response.data.customerRedirect;
                      }

                    } else {
                      flash('Error submitting new Transactions', 'danger');
                      console.log('submitNewTransactions', response.data);
                      console.log('submitNewTransactions', response.status);
                      console.log('submitNewTransactions', response.statusText);
                    }

                    this.loading(false);
                  })
                  .catch((error) => {
                    flash('Error submitting new Transactions', 'danger');
                    if (error.response) {
                      // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
                      if (error.response.status == 422) {
                        console.log('submitNewTransactions: laravel validation error', error.response.data);
                      }
                      // else if HTTP_CONFLICT to many saleables or over lap
                      else if (error.response.status == 409) {
                        this.lockError = error.response.data;
                      }
                      // else if HTTP_FORBIDDEN on enough permissions
                      else if (error.response.status == 401) {
                        // else if HTTP_UNAUTHORIZED not authorized
                        console.log('submitNewTransactions:401', error.response.data);
                      }
                      else {
                        console.log('submitNewTransactions: Response error', error.response.data, error.response.status, error.response.headers);
                      }
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.error('submitNewTransactions: Request error', error.request);
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.error('submitNewTransactions: Error', error.message);
                    }
                    this.loading(false);
                  });

              } else {
                this.disablePayButton = true;
                this.$refs.payComponent.takeSalePayment(this.sale, null, deposit === true ? true : false);
              }
            });
          } else {
            this.enableCartEchoUpdate();

            flash('Error with Cart checkout', 'danger');
            console.log('cartCheckout', response.data);
            console.log('cartCheckout', response.status);
            console.log('cartCheckout', response.statusText);
          }

          this.loading(false);
        })
        .catch((error) => {
          this.enableCartEchoUpdate();

          let showError = true;

          if (error.response) {
            if (error.response.status == 422) {
              // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
              console.log('cartCheckout:422', error.response.data);
              if (error.response.data.errors) {
                const errors = error.response.data.errors;

                Object.keys(errors).forEach(function(key) {
                  errors[key].forEach(error => flash(error, 'danger'));
                });
              } else {
                flash(error.response.data, 'danger');
              }
            } else if (error.response.status == 409 && error.response.data.message == 'Blocklist email') {
              // else if HTTP_CONFLICT && Blocklist Email

              $(this.$refs.loadingModal).modal('show');
              showError = false;
            } else if (error.response.status == 409) {
              // else if HTTP_CONFLICT
              console.log('cartCheckout:409', error.response.data);
              this.locationQuestionsError = error.response.data.message;
            } else if (error.response.status == 403) {
              // else if HTTP_FORBIDDEN on enough permissions
              console.log('cartCheckout:403', error.response.data);
            } else if (error.response.status == 401) {
              // else if HTTP_UNAUTHORIZED not authorized
              console.log('cartCheckout:401', error.response.data);
            } else {
              console.log('cartCheckout: Response error', error.response.data, error.response.status, error.response.headers);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.error('cartCheckout: Request error', error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.error('cartCheckout: Error', error.message);
          }

          this.loading(false);

          if (showError) {
            flash('Error with Cart checkout', 'danger');
            console.log('error.response', error.response)
          }
        });
    }, // takePaymentCart()

    scrollToPayment() {
      this.scrollDomIdIntoView('payment_card_input');
      return; // BELOW is pre 2025-04-07, where the DOM was whizzing all over the place, and past the bounds of the iFrame

      if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToPayment');
      const elm = document.getElementById('payment_card_input');

      if (this.external === false) {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToPayment - external === false - about to scroll to ID:payment_card_input', elm.getBoundingClientRect().top);

        elm.scrollIntoView({ behavior: 'smooth', block: 'start',}); // If not scroll into view as usual.
      } else {
        if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToPayment - external is TRUE - about to scroll to ID:payment_card_input', elm.getBoundingClientRect().top);
        if (this.requiresIframeScrollFix()) {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToPayment - a postMessage is about to fire');
          window.top.postMessage(['move', elm.getBoundingClientRect().bottom], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
        } else {
          if (this.consoleDebug) console.log('BookingCheckoutIframe::scrollToPayment - scrollIntoView is about to fire');
          setTimeout(() => {
            elm.scrollIntoView({ behavior: 'smooth', block: 'end',}); // If not scroll into view as usual.
          }, 100);
        }
      }
    },

    sendTransactionToTaggers(sale_id) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::sendTransactionToTaggers', sale_id);
      if (this.sale.id != sale_id) {
        console.log('BookingCheckoutIframe::sendTransactionToTaggers - sale_id does not match this.sale.id', sale_id, this.sale?.id);
        return false;
      }
      if (this.sale.transactions.length < 1) {
        console.log('BookingCheckoutIframe::sendTransactionToTaggers - no transactions on sale', this.sale?.transactions);
        return false;
      }
      if (this.transactionAmountReceived === null) {
        console.log('BookingCheckoutIframe::sendTransactionToTaggers - transactionAmountReceived is null');
        return false;
      }
      // tests should prove we have a sale, we have a transaction
      // so now we need to find it

      var transactions = this.sale.transactions.filter(tx => tx.amount == this.transactionAmountReceived);
      if (transactions.length == 0) {
        console.log('BookingCheckoutIframe::sendTransactionToTaggers - cannot find the transaction, so bailing', this.sale.transactions);
        return false;
      }
      var transaction = transactions.reduce((a, b) => (a.created_at > b.created_at ? a : b));
      if (this.consoleDebug) console.log('BookingCheckoutIframe::sendTransactionToTaggers - transaction', transaction);

      var purchaseObject = {};

      purchaseObject.transaction_id = "TX_" + transaction.id;
      purchaseObject.value = transaction.amount / 100;
      // purchaseObject.tax: 3.60,
      // purchaseObject.shipping: 5.99,
      purchaseObject.currency = this.$currencyCode;
      // purchaseObject.coupon: "SUMMER_SALE",

      var saleItems = [];
      var idx = 0;
      this.sale.sale_items.forEach(si => {
        const saleItemObject = {};
        saleItemObject.item_id = si.sku;
        saleItemObject.item_name = si.description,
        saleItemObject.affiliation = "ER Tempus Sale";
        // saleItemObject.coupon: "SUMMER_FUN";
        // saleItemObject.discount: 2.22;
        saleItemObject.index = idx++;
        // item_brand: "Google";
        saleItemObject.item_category = si.saleable_type.split('App\\Models\\')[1];
        // item_category2: "Adult";
        // item_category3: "Shirts";
        // item_category4: "Crew";
        // item_category5: "Short sleeve";
        // item_list_id: "related_products";
        // item_list_name: "Related Products";
        // item_variant: "green";
        // location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo";
        saleItemObject.price = si.sold_for / 100;
        saleItemObject.quantity = 1;
        saleItems.push(saleItemObject);
      });

      purchaseObject.items = saleItems;

      if (this.consoleDebug) console.log('BookingCheckoutIframe::sendTransactionToTaggers - purchaseObject', purchaseObject);

      this.sendToGoogleEcommerce('purchase', purchaseObject);
      this.sendToFacebookPixelEcommerce({currency: this.$currencyCode, value: transaction.amount / 100});

      this.transactionAmountReceived = null;
    },

    sendToGoogleEcommerce(event, object) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::sendToGoogleEcommerce', event, object);
      if (this.external) {
        window.top.postMessage(['gtagEvent', {event: event, ecommerce: object}], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
      } else {
        if (window.dataLayer) {
          window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
          window.dataLayer.push({
            event: event,
            ecommerce: object
          });
        }
      }
    },

    sendToFacebookPixelEcommerce(purchaseObject) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::sendToFacebookPixelEcommerce', purchaseObject);
      if (this.external) {
        window.top.postMessage(['fbq', purchaseObject], "*"); // Tell IFrame parent to do the scrolling. If this is not a test environment, replace "*" with the parent domain.
      } else {
        if (typeof fbq !== 'undefined') {
          fbq('track', 'Purchase', purchaseObject);
        }
      }
    },

    /*
     * =====================================
     * End of CHECKOUT methods
     */

    /* ===============
     * Echo methods
     *
     * 1) echoInitCart()
     * 2) echoDeInitCart()
     * 3) enableCartEchoUpdate()
     * 4) disableCartEchoUpdate()
     * 5) cartSavedEvent(event)
     *
     */

    echoInitCart() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::echoInitCart')
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      // TODO: MT bypassed this for error checking on 2025-01-23
      return;

      Echo.channel('cart.session.' + this.cart.session)
        .listen('Cart.CartSaved', this.cartSavedEvent);

      this.enableCartEchoUpdate();
    },

    echoDeInitCart() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::echoDeInitCart')
      if (! process.env.MIX_PUSHER_APP_KEY) {
        return;
      }

      // TODO: MT bypassed this for error checking on 2025-01-23
      return;

      Echo.leave('cart.session.' + this.cart.session);
      Echo.leave('booking-calendar.cart.session.' + this.cart.session)
    },

    enableCartEchoUpdate() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::enableCartEchoUpdate')

      // TODO: MT bypassed this for error checking on 2025-01-23
      return;
      this.disableCartEchoUpdateFlag = false;

      if (this.temporaryCart) {
        this.cart = this.temporaryCart;
        this.temporaryCart = null;
      }
    },

    disableCartEchoUpdate() {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::disableCartEchoUpdate')

      // TODO: MT bypassed this for error checking on 2025-01-23
      return;
      this.disableCartEchoUpdateFlag = true;
      this.temporaryCart = null;
    },

    cartSavedEvent(event) {
      if (this.consoleDebug) console.log('BookingCheckoutIframe::cartSavedEvent(event)', event);

      // TODO: MT bypassed this for error checking on 2025-01-23
      return;
      if (! this.disableCartEchoUpdateFlag) {
        this.cart = event.cart;
      } else {
        this.temporaryCart = event.cart;
      }
    },

    /*
     * END Echo methods
     * =============== */

    /* ===============
     * iFrame methods
     *
     * 1) iFrameResize()
     *
     */

    // https://stackoverflow.com/questions/9162933/make-iframe-height-dynamic-based-on-content-inside-jquery-javascript
    //
    iFrameResize(size) {
      // eventer code here
      //
      // https://stackoverflow.com/questions/153152/resizing-an-iframe-based-on-content

      // console.log('iFrameResize', size);
      window.top.postMessage(["changeHeight", parseInt(size)], "*");
    },

    /*
     * END iFrame methods
     * ================== */

    preventNav(event) {
      if (! this.cartInProgress) return
      event.preventDefault();
      event.returnValue = "Cart will be lost, are you sure you want to leave before checking out?";
    },
  },

  mounted() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentBoxSize) {
          if (entry.contentBoxSize[0]) {
            this.iFrameResize(entries[0].contentBoxSize[0].blockSize);
          }
        }
      }
    });

    this.resizeObserver.observe(this.$refs.thisMainDiv);

    this.echoInitCart();

    if (this.cartOrSale == 'sale' && this.sale.transactions && this.sale.transactions.length && this.sale.totalTransactionsAmount != 0) {
      // we are dealing with a sale with transactions,

      if (this.requiredLocationQuestionsAnswered) {
        // all location questions are answered, so minimise it
        this.locationQuestionsMinimised = true;
      }

      if (this.locationQuestionsRequired.length) {
        // hide addOns
        this.showLocationAddOns = false;
      }
    }

    this.init();

    if (this.firstShow == 'DEFAULT' || this.firstShow == 'v') {
      // Vue handles these calendars
    } else {
      // this will be a room calendar
      let roomId = this.firstShow.split('-').length > 1 ? this.firstShow.split('-')[1] : null;
      if (roomId) {
        this.showRoomCalendarOnLoad = roomId;
      }
    }

    if (this.consoleDebug) console.log('External: ', this.external);
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
  },

  beforeRouteLeave(to, from, next) {
    if (this.cartInProgress) {
      if (! window.confirm("Cart will be lost, are you sure you want to leave before checking out?")) {
        return;
      }
    }
    next();
  },

  beforeDestroy() {
    this.echoDeInitCart();
    window.removeEventListener("beforeunload", this.preventNav);
  },
}
</script>
